/* Do not edit this file */
!function(t, e) {
    "object" == typeof module && "object" == typeof module.exports ? module.exports = t.document ? e(t, !0) : function(t) {
        if (!t.document)
            throw new Error("jQuery requires a window with a document");
        return e(t)
    }
    : e(t)
}("undefined" != typeof window ? window : this, function(t, e) {
    var n = []
      , i = t.document
      , r = n.slice
      , o = n.concat
      , a = n.push
      , s = n.indexOf
      , c = {}
      , u = c.toString
      , l = c.hasOwnProperty
      , d = {}
      , p = "2.2.3"
      , f = function(t, e) {
        return new f.fn.init(t,e)
    }
      , h = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g
      , g = /^-ms-/
      , m = /-([\da-z])/gi
      , v = function(t, e) {
        return e.toUpperCase()
    };
    function y(t) {
        var e = !!t && "length"in t && t.length
          , n = f.type(t);
        return "function" !== n && !f.isWindow(t) && ("array" === n || 0 === e || "number" == typeof e && e > 0 && e - 1 in t)
    }
    f.fn = f.prototype = {
        jquery: p,
        constructor: f,
        selector: "",
        length: 0,
        toArray: function() {
            return r.call(this)
        },
        get: function(t) {
            return null != t ? 0 > t ? this[t + this.length] : this[t] : r.call(this)
        },
        pushStack: function(t) {
            var e = f.merge(this.constructor(), t);
            return e.prevObject = this,
            e.context = this.context,
            e
        },
        each: function(t) {
            return f.each(this, t)
        },
        map: function(t) {
            return this.pushStack(f.map(this, function(e, n) {
                return t.call(e, n, e)
            }))
        },
        slice: function() {
            return this.pushStack(r.apply(this, arguments))
        },
        first: function() {
            return this.eq(0)
        },
        last: function() {
            return this.eq(-1)
        },
        eq: function(t) {
            var e = this.length
              , n = +t + (0 > t ? e : 0);
            return this.pushStack(n >= 0 && e > n ? [this[n]] : [])
        },
        end: function() {
            return this.prevObject || this.constructor()
        },
        push: a,
        sort: n.sort,
        splice: n.splice
    },
    f.extend = f.fn.extend = function() {
        var t, e, n, i, r, o, a = arguments[0] || {}, s = 1, c = arguments.length, u = !1;
        for ("boolean" == typeof a && (u = a,
        a = arguments[s] || {},
        s++),
        "object" == typeof a || f.isFunction(a) || (a = {}),
        s === c && (a = this,
        s--); c > s; s++)
            if (null != (t = arguments[s]))
                for (e in t)
                    n = a[e],
                    a !== (i = t[e]) && (u && i && (f.isPlainObject(i) || (r = f.isArray(i))) ? (r ? (r = !1,
                    o = n && f.isArray(n) ? n : []) : o = n && f.isPlainObject(n) ? n : {},
                    a[e] = f.extend(u, o, i)) : void 0 !== i && (a[e] = i));
        return a
    }
    ,
    f.extend({
        expando: "jQuery" + (p + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function(t) {
            throw new Error(t)
        },
        noop: function() {},
        isFunction: function(t) {
            return "function" === f.type(t)
        },
        isArray: Array.isArray,
        isWindow: function(t) {
            return null != t && t === t.window
        },
        isNumeric: function(t) {
            var e = t && t.toString();
            return !f.isArray(t) && e - parseFloat(e) + 1 >= 0
        },
        isPlainObject: function(t) {
            var e;
            if ("object" !== f.type(t) || t.nodeType || f.isWindow(t))
                return !1;
            if (t.constructor && !l.call(t, "constructor") && !l.call(t.constructor.prototype || {}, "isPrototypeOf"))
                return !1;
            for (e in t)
                ;
            return void 0 === e || l.call(t, e)
        },
        isEmptyObject: function(t) {
            var e;
            for (e in t)
                return !1;
            return !0
        },
        type: function(t) {
            return null == t ? t + "" : "object" == typeof t || "function" == typeof t ? c[u.call(t)] || "object" : typeof t
        },
        globalEval: function(t) {
            var e, n = eval;
            (t = f.trim(t)) && (1 === t.indexOf("use strict") ? ((e = i.createElement("script")).text = t,
            i.head.appendChild(e).parentNode.removeChild(e)) : n(t))
        },
        camelCase: function(t) {
            return t.replace(g, "ms-").replace(m, v)
        },
        nodeName: function(t, e) {
            return t.nodeName && t.nodeName.toLowerCase() === e.toLowerCase()
        },
        each: function(t, e) {
            var n, i = 0;
            if (y(t))
                for (n = t.length; n > i && !1 !== e.call(t[i], i, t[i]); i++)
                    ;
            else
                for (i in t)
                    if (!1 === e.call(t[i], i, t[i]))
                        break;
            return t
        },
        trim: function(t) {
            return null == t ? "" : (t + "").replace(h, "")
        },
        makeArray: function(t, e) {
            var n = e || [];
            return null != t && (y(Object(t)) ? f.merge(n, "string" == typeof t ? [t] : t) : a.call(n, t)),
            n
        },
        inArray: function(t, e, n) {
            return null == e ? -1 : s.call(e, t, n)
        },
        merge: function(t, e) {
            for (var n = +e.length, i = 0, r = t.length; n > i; i++)
                t[r++] = e[i];
            return t.length = r,
            t
        },
        grep: function(t, e, n) {
            for (var i = [], r = 0, o = t.length, a = !n; o > r; r++)
                !e(t[r], r) !== a && i.push(t[r]);
            return i
        },
        map: function(t, e, n) {
            var i, r, a = 0, s = [];
            if (y(t))
                for (i = t.length; i > a; a++)
                    null != (r = e(t[a], a, n)) && s.push(r);
            else
                for (a in t)
                    null != (r = e(t[a], a, n)) && s.push(r);
            return o.apply([], s)
        },
        guid: 1,
        proxy: function(t, e) {
            var n, i, o;
            return "string" == typeof e && (n = t[e],
            e = t,
            t = n),
            f.isFunction(t) ? (i = r.call(arguments, 2),
            (o = function() {
                return t.apply(e || this, i.concat(r.call(arguments)))
            }
            ).guid = t.guid = t.guid || f.guid++,
            o) : void 0
        },
        now: Date.now,
        support: d
    }),
    "function" == typeof Symbol && (f.fn[Symbol.iterator] = n[Symbol.iterator]),
    f.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(t, e) {
        c["[object " + e + "]"] = e.toLowerCase()
    });
    var b = function(t) {
        var e, n, i, r, o, a, s, c, u, l, d, p, f, h, g, m, v, y, b, P = "sizzle" + 1 * new Date, w = t.document, k = 0, x = 0, C = ot(), O = ot(), j = ot(), T = function(t, e) {
            return t === e && (d = !0),
            0
        }, _ = 1 << 31, G = {}.hasOwnProperty, S = [], F = S.pop, A = S.push, D = S.push, L = S.slice, Q = function(t, e) {
            for (var n = 0, i = t.length; i > n; n++)
                if (t[n] === e)
                    return n;
            return -1
        }, q = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", N = "[\\x20\\t\\r\\n\\f]", E = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+", M = "\\[" + N + "*(" + E + ")(?:" + N + "*([*^$|!~]?=)" + N + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + E + "))|)" + N + "*\\]", H = ":(" + E + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + M + ")*)|.*)\\)|)", B = new RegExp(N + "+","g"), I = new RegExp("^" + N + "+|((?:^|[^\\\\])(?:\\\\.)*)" + N + "+$","g"), $ = new RegExp("^" + N + "*," + N + "*"), V = new RegExp("^" + N + "*([>+~]|" + N + ")" + N + "*"), R = new RegExp("=" + N + "*([^\\]'\"]*?)" + N + "*\\]","g"), W = new RegExp(H), z = new RegExp("^" + E + "$"), X = {
            ID: new RegExp("^#(" + E + ")"),
            CLASS: new RegExp("^\\.(" + E + ")"),
            TAG: new RegExp("^(" + E + "|[*])"),
            ATTR: new RegExp("^" + M),
            PSEUDO: new RegExp("^" + H),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + N + "*(even|odd|(([+-]|)(\\d*)n|)" + N + "*(?:([+-]|)" + N + "*(\\d+)|))" + N + "*\\)|)","i"),
            bool: new RegExp("^(?:" + q + ")$","i"),
            needsContext: new RegExp("^" + N + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + N + "*((?:-\\d)?\\d*)" + N + "*\\)|)(?=[^-]|$)","i")
        }, U = /^(?:input|select|textarea|button)$/i, Y = /^h\d$/i, J = /^[^{]+\{\s*\[native \w/, K = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, Z = /[+~]/, tt = /'|\\/g, et = new RegExp("\\\\([\\da-f]{1,6}" + N + "?|(" + N + ")|.)","ig"), nt = function(t, e, n) {
            var i = "0x" + e - 65536;
            return i != i || n ? e : 0 > i ? String.fromCharCode(i + 65536) : String.fromCharCode(i >> 10 | 55296, 1023 & i | 56320)
        }, it = function() {
            p()
        };
        try {
            D.apply(S = L.call(w.childNodes), w.childNodes),
            S[w.childNodes.length].nodeType
        } catch (t) {
            D = {
                apply: S.length ? function(t, e) {
                    A.apply(t, L.call(e))
                }
                : function(t, e) {
                    for (var n = t.length, i = 0; t[n++] = e[i++]; )
                        ;
                    t.length = n - 1
                }
            }
        }
        function rt(t, e, i, r) {
            var o, s, u, l, d, h, v, y, k = e && e.ownerDocument, x = e ? e.nodeType : 9;
            if (i = i || [],
            "string" != typeof t || !t || 1 !== x && 9 !== x && 11 !== x)
                return i;
            if (!r && ((e ? e.ownerDocument || e : w) !== f && p(e),
            e = e || f,
            g)) {
                if (11 !== x && (h = K.exec(t)))
                    if (o = h[1]) {
                        if (9 === x) {
                            if (!(u = e.getElementById(o)))
                                return i;
                            if (u.id === o)
                                return i.push(u),
                                i
                        } else if (k && (u = k.getElementById(o)) && b(e, u) && u.id === o)
                            return i.push(u),
                            i
                    } else {
                        if (h[2])
                            return D.apply(i, e.getElementsByTagName(t)),
                            i;
                        if ((o = h[3]) && n.getElementsByClassName && e.getElementsByClassName)
                            return D.apply(i, e.getElementsByClassName(o)),
                            i
                    }
                if (n.qsa && !j[t + " "] && (!m || !m.test(t))) {
                    if (1 !== x)
                        k = e,
                        y = t;
                    else if ("object" !== e.nodeName.toLowerCase()) {
                        for ((l = e.getAttribute("id")) ? l = l.replace(tt, "\\$&") : e.setAttribute("id", l = P),
                        s = (v = a(t)).length,
                        d = z.test(l) ? "#" + l : "[id='" + l + "']"; s--; )
                            v[s] = d + " " + gt(v[s]);
                        y = v.join(","),
                        k = Z.test(t) && ft(e.parentNode) || e
                    }
                    if (y)
                        try {
                            return D.apply(i, k.querySelectorAll(y)),
                            i
                        } catch (t) {} finally {
                            l === P && e.removeAttribute("id")
                        }
                }
            }
            return c(t.replace(I, "$1"), e, i, r)
        }
        function ot() {
            var t = [];
            return function e(n, r) {
                return t.push(n + " ") > i.cacheLength && delete e[t.shift()],
                e[n + " "] = r
            }
        }
        function at(t) {
            return t[P] = !0,
            t
        }
        function st(t) {
            var e = f.createElement("div");
            try {
                return !!t(e)
            } catch (t) {
                return !1
            } finally {
                e.parentNode && e.parentNode.removeChild(e),
                e = null
            }
        }
        function ct(t, e) {
            for (var n = t.split("|"), r = n.length; r--; )
                i.attrHandle[n[r]] = e
        }
        function ut(t, e) {
            var n = e && t
              , i = n && 1 === t.nodeType && 1 === e.nodeType && (~e.sourceIndex || _) - (~t.sourceIndex || _);
            if (i)
                return i;
            if (n)
                for (; n = n.nextSibling; )
                    if (n === e)
                        return -1;
            return t ? 1 : -1
        }
        function lt(t) {
            return function(e) {
                return "input" === e.nodeName.toLowerCase() && e.type === t
            }
        }
        function dt(t) {
            return function(e) {
                var n = e.nodeName.toLowerCase();
                return ("input" === n || "button" === n) && e.type === t
            }
        }
        function pt(t) {
            return at(function(e) {
                return e = +e,
                at(function(n, i) {
                    for (var r, o = t([], n.length, e), a = o.length; a--; )
                        n[r = o[a]] && (n[r] = !(i[r] = n[r]))
                })
            })
        }
        function ft(t) {
            return t && void 0 !== t.getElementsByTagName && t
        }
        for (e in n = rt.support = {},
        o = rt.isXML = function(t) {
            var e = t && (t.ownerDocument || t).documentElement;
            return !!e && "HTML" !== e.nodeName
        }
        ,
        p = rt.setDocument = function(t) {
            var e, r, a = t ? t.ownerDocument || t : w;
            return a !== f && 9 === a.nodeType && a.documentElement ? (h = (f = a).documentElement,
            g = !o(f),
            (r = f.defaultView) && r.top !== r && (r.addEventListener ? r.addEventListener("unload", it, !1) : r.attachEvent && r.attachEvent("onunload", it)),
            n.attributes = st(function(t) {
                return t.className = "i",
                !t.getAttribute("className")
            }),
            n.getElementsByTagName = st(function(t) {
                return t.appendChild(f.createComment("")),
                !t.getElementsByTagName("*").length
            }),
            n.getElementsByClassName = J.test(f.getElementsByClassName),
            n.getById = st(function(t) {
                return h.appendChild(t).id = P,
                !f.getElementsByName || !f.getElementsByName(P).length
            }),
            n.getById ? (i.find.ID = function(t, e) {
                if (void 0 !== e.getElementById && g) {
                    var n = e.getElementById(t);
                    return n ? [n] : []
                }
            }
            ,
            i.filter.ID = function(t) {
                var e = t.replace(et, nt);
                return function(t) {
                    return t.getAttribute("id") === e
                }
            }
            ) : (delete i.find.ID,
            i.filter.ID = function(t) {
                var e = t.replace(et, nt);
                return function(t) {
                    var n = void 0 !== t.getAttributeNode && t.getAttributeNode("id");
                    return n && n.value === e
                }
            }
            ),
            i.find.TAG = n.getElementsByTagName ? function(t, e) {
                return void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t) : n.qsa ? e.querySelectorAll(t) : void 0
            }
            : function(t, e) {
                var n, i = [], r = 0, o = e.getElementsByTagName(t);
                if ("*" === t) {
                    for (; n = o[r++]; )
                        1 === n.nodeType && i.push(n);
                    return i
                }
                return o
            }
            ,
            i.find.CLASS = n.getElementsByClassName && function(t, e) {
                return void 0 !== e.getElementsByClassName && g ? e.getElementsByClassName(t) : void 0
            }
            ,
            v = [],
            m = [],
            (n.qsa = J.test(f.querySelectorAll)) && (st(function(t) {
                h.appendChild(t).innerHTML = "<a id='" + P + "'></a><select id='" + P + "-\r\\' msallowcapture=''><option selected=''></option></select>",
                t.querySelectorAll("[msallowcapture^='']").length && m.push("[*^$]=" + N + "*(?:''|\"\")"),
                t.querySelectorAll("[selected]").length || m.push("\\[" + N + "*(?:value|" + q + ")"),
                t.querySelectorAll("[id~=" + P + "-]").length || m.push("~="),
                t.querySelectorAll(":checked").length || m.push(":checked"),
                t.querySelectorAll("a#" + P + "+*").length || m.push(".#.+[+~]")
            }),
            st(function(t) {
                var e = f.createElement("input");
                e.setAttribute("type", "hidden"),
                t.appendChild(e).setAttribute("name", "D"),
                t.querySelectorAll("[name=d]").length && m.push("name" + N + "*[*^$|!~]?="),
                t.querySelectorAll(":enabled").length || m.push(":enabled", ":disabled"),
                t.querySelectorAll("*,:x"),
                m.push(",.*:")
            })),
            (n.matchesSelector = J.test(y = h.matches || h.webkitMatchesSelector || h.mozMatchesSelector || h.oMatchesSelector || h.msMatchesSelector)) && st(function(t) {
                n.disconnectedMatch = y.call(t, "div"),
                y.call(t, "[s!='']:x"),
                v.push("!=", H)
            }),
            m = m.length && new RegExp(m.join("|")),
            v = v.length && new RegExp(v.join("|")),
            e = J.test(h.compareDocumentPosition),
            b = e || J.test(h.contains) ? function(t, e) {
                var n = 9 === t.nodeType ? t.documentElement : t
                  , i = e && e.parentNode;
                return t === i || !(!i || 1 !== i.nodeType || !(n.contains ? n.contains(i) : t.compareDocumentPosition && 16 & t.compareDocumentPosition(i)))
            }
            : function(t, e) {
                if (e)
                    for (; e = e.parentNode; )
                        if (e === t)
                            return !0;
                return !1
            }
            ,
            T = e ? function(t, e) {
                if (t === e)
                    return d = !0,
                    0;
                var i = !t.compareDocumentPosition - !e.compareDocumentPosition;
                return i || (1 & (i = (t.ownerDocument || t) === (e.ownerDocument || e) ? t.compareDocumentPosition(e) : 1) || !n.sortDetached && e.compareDocumentPosition(t) === i ? t === f || t.ownerDocument === w && b(w, t) ? -1 : e === f || e.ownerDocument === w && b(w, e) ? 1 : l ? Q(l, t) - Q(l, e) : 0 : 4 & i ? -1 : 1)
            }
            : function(t, e) {
                if (t === e)
                    return d = !0,
                    0;
                var n, i = 0, r = t.parentNode, o = e.parentNode, a = [t], s = [e];
                if (!r || !o)
                    return t === f ? -1 : e === f ? 1 : r ? -1 : o ? 1 : l ? Q(l, t) - Q(l, e) : 0;
                if (r === o)
                    return ut(t, e);
                for (n = t; n = n.parentNode; )
                    a.unshift(n);
                for (n = e; n = n.parentNode; )
                    s.unshift(n);
                for (; a[i] === s[i]; )
                    i++;
                return i ? ut(a[i], s[i]) : a[i] === w ? -1 : s[i] === w ? 1 : 0
            }
            ,
            f) : f
        }
        ,
        rt.matches = function(t, e) {
            return rt(t, null, null, e)
        }
        ,
        rt.matchesSelector = function(t, e) {
            if ((t.ownerDocument || t) !== f && p(t),
            e = e.replace(R, "='$1']"),
            n.matchesSelector && g && !j[e + " "] && (!v || !v.test(e)) && (!m || !m.test(e)))
                try {
                    var i = y.call(t, e);
                    if (i || n.disconnectedMatch || t.document && 11 !== t.document.nodeType)
                        return i
                } catch (t) {}
            return rt(e, f, null, [t]).length > 0
        }
        ,
        rt.contains = function(t, e) {
            return (t.ownerDocument || t) !== f && p(t),
            b(t, e)
        }
        ,
        rt.attr = function(t, e) {
            (t.ownerDocument || t) !== f && p(t);
            var r = i.attrHandle[e.toLowerCase()]
              , o = r && G.call(i.attrHandle, e.toLowerCase()) ? r(t, e, !g) : void 0;
            return void 0 !== o ? o : n.attributes || !g ? t.getAttribute(e) : (o = t.getAttributeNode(e)) && o.specified ? o.value : null
        }
        ,
        rt.error = function(t) {
            throw new Error("Syntax error, unrecognized expression: " + t)
        }
        ,
        rt.uniqueSort = function(t) {
            var e, i = [], r = 0, o = 0;
            if (d = !n.detectDuplicates,
            l = !n.sortStable && t.slice(0),
            t.sort(T),
            d) {
                for (; e = t[o++]; )
                    e === t[o] && (r = i.push(o));
                for (; r--; )
                    t.splice(i[r], 1)
            }
            return l = null,
            t
        }
        ,
        r = rt.getText = function(t) {
            var e, n = "", i = 0, o = t.nodeType;
            if (o) {
                if (1 === o || 9 === o || 11 === o) {
                    if ("string" == typeof t.textContent)
                        return t.textContent;
                    for (t = t.firstChild; t; t = t.nextSibling)
                        n += r(t)
                } else if (3 === o || 4 === o)
                    return t.nodeValue
            } else
                for (; e = t[i++]; )
                    n += r(e);
            return n
        }
        ,
        (i = rt.selectors = {
            cacheLength: 50,
            createPseudo: at,
            match: X,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: !0
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: !0
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(t) {
                    return t[1] = t[1].replace(et, nt),
                    t[3] = (t[3] || t[4] || t[5] || "").replace(et, nt),
                    "~=" === t[2] && (t[3] = " " + t[3] + " "),
                    t.slice(0, 4)
                },
                CHILD: function(t) {
                    return t[1] = t[1].toLowerCase(),
                    "nth" === t[1].slice(0, 3) ? (t[3] || rt.error(t[0]),
                    t[4] = +(t[4] ? t[5] + (t[6] || 1) : 2 * ("even" === t[3] || "odd" === t[3])),
                    t[5] = +(t[7] + t[8] || "odd" === t[3])) : t[3] && rt.error(t[0]),
                    t
                },
                PSEUDO: function(t) {
                    var e, n = !t[6] && t[2];
                    return X.CHILD.test(t[0]) ? null : (t[3] ? t[2] = t[4] || t[5] || "" : n && W.test(n) && (e = a(n, !0)) && (e = n.indexOf(")", n.length - e) - n.length) && (t[0] = t[0].slice(0, e),
                    t[2] = n.slice(0, e)),
                    t.slice(0, 3))
                }
            },
            filter: {
                TAG: function(t) {
                    var e = t.replace(et, nt).toLowerCase();
                    return "*" === t ? function() {
                        return !0
                    }
                    : function(t) {
                        return t.nodeName && t.nodeName.toLowerCase() === e
                    }
                },
                CLASS: function(t) {
                    var e = C[t + " "];
                    return e || (e = new RegExp("(^|" + N + ")" + t + "(" + N + "|$)")) && C(t, function(t) {
                        return e.test("string" == typeof t.className && t.className || void 0 !== t.getAttribute && t.getAttribute("class") || "")
                    })
                },
                ATTR: function(t, e, n) {
                    return function(i) {
                        var r = rt.attr(i, t);
                        return null == r ? "!=" === e : !e || (r += "",
                        "=" === e ? r === n : "!=" === e ? r !== n : "^=" === e ? n && 0 === r.indexOf(n) : "*=" === e ? n && r.indexOf(n) > -1 : "$=" === e ? n && r.slice(-n.length) === n : "~=" === e ? (" " + r.replace(B, " ") + " ").indexOf(n) > -1 : "|=" === e && (r === n || r.slice(0, n.length + 1) === n + "-"))
                    }
                },
                CHILD: function(t, e, n, i, r) {
                    var o = "nth" !== t.slice(0, 3)
                      , a = "last" !== t.slice(-4)
                      , s = "of-type" === e;
                    return 1 === i && 0 === r ? function(t) {
                        return !!t.parentNode
                    }
                    : function(e, n, c) {
                        var u, l, d, p, f, h, g = o !== a ? "nextSibling" : "previousSibling", m = e.parentNode, v = s && e.nodeName.toLowerCase(), y = !c && !s, b = !1;
                        if (m) {
                            if (o) {
                                for (; g; ) {
                                    for (p = e; p = p[g]; )
                                        if (s ? p.nodeName.toLowerCase() === v : 1 === p.nodeType)
                                            return !1;
                                    h = g = "only" === t && !h && "nextSibling"
                                }
                                return !0
                            }
                            if (h = [a ? m.firstChild : m.lastChild],
                            a && y) {
                                for (b = (f = (u = (l = (d = (p = m)[P] || (p[P] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[t] || [])[0] === k && u[1]) && u[2],
                                p = f && m.childNodes[f]; p = ++f && p && p[g] || (b = f = 0) || h.pop(); )
                                    if (1 === p.nodeType && ++b && p === e) {
                                        l[t] = [k, f, b];
                                        break
                                    }
                            } else if (y && (b = f = (u = (l = (d = (p = e)[P] || (p[P] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[t] || [])[0] === k && u[1]),
                            !1 === b)
                                for (; (p = ++f && p && p[g] || (b = f = 0) || h.pop()) && ((s ? p.nodeName.toLowerCase() !== v : 1 !== p.nodeType) || !++b || (y && ((l = (d = p[P] || (p[P] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[t] = [k, b]),
                                p !== e)); )
                                    ;
                            return (b -= r) === i || b % i == 0 && b / i >= 0
                        }
                    }
                },
                PSEUDO: function(t, e) {
                    var n, r = i.pseudos[t] || i.setFilters[t.toLowerCase()] || rt.error("unsupported pseudo: " + t);
                    return r[P] ? r(e) : r.length > 1 ? (n = [t, t, "", e],
                    i.setFilters.hasOwnProperty(t.toLowerCase()) ? at(function(t, n) {
                        for (var i, o = r(t, e), a = o.length; a--; )
                            t[i = Q(t, o[a])] = !(n[i] = o[a])
                    }) : function(t) {
                        return r(t, 0, n)
                    }
                    ) : r
                }
            },
            pseudos: {
                not: at(function(t) {
                    var e = []
                      , n = []
                      , i = s(t.replace(I, "$1"));
                    return i[P] ? at(function(t, e, n, r) {
                        for (var o, a = i(t, null, r, []), s = t.length; s--; )
                            (o = a[s]) && (t[s] = !(e[s] = o))
                    }) : function(t, r, o) {
                        return e[0] = t,
                        i(e, null, o, n),
                        e[0] = null,
                        !n.pop()
                    }
                }),
                has: at(function(t) {
                    return function(e) {
                        return rt(t, e).length > 0
                    }
                }),
                contains: at(function(t) {
                    return t = t.replace(et, nt),
                    function(e) {
                        return (e.textContent || e.innerText || r(e)).indexOf(t) > -1
                    }
                }),
                lang: at(function(t) {
                    return z.test(t || "") || rt.error("unsupported lang: " + t),
                    t = t.replace(et, nt).toLowerCase(),
                    function(e) {
                        var n;
                        do {
                            if (n = g ? e.lang : e.getAttribute("xml:lang") || e.getAttribute("lang"))
                                return (n = n.toLowerCase()) === t || 0 === n.indexOf(t + "-")
                        } while ((e = e.parentNode) && 1 === e.nodeType);return !1
                    }
                }),
                target: function(e) {
                    var n = t.location && t.location.hash;
                    return n && n.slice(1) === e.id
                },
                root: function(t) {
                    return t === h
                },
                focus: function(t) {
                    return t === f.activeElement && (!f.hasFocus || f.hasFocus()) && !!(t.type || t.href || ~t.tabIndex)
                },
                enabled: function(t) {
                    return !1 === t.disabled
                },
                disabled: function(t) {
                    return !0 === t.disabled
                },
                checked: function(t) {
                    var e = t.nodeName.toLowerCase();
                    return "input" === e && !!t.checked || "option" === e && !!t.selected
                },
                selected: function(t) {
                    return t.parentNode && t.parentNode.selectedIndex,
                    !0 === t.selected
                },
                empty: function(t) {
                    for (t = t.firstChild; t; t = t.nextSibling)
                        if (t.nodeType < 6)
                            return !1;
                    return !0
                },
                parent: function(t) {
                    return !i.pseudos.empty(t)
                },
                header: function(t) {
                    return Y.test(t.nodeName)
                },
                input: function(t) {
                    return U.test(t.nodeName)
                },
                button: function(t) {
                    var e = t.nodeName.toLowerCase();
                    return "input" === e && "button" === t.type || "button" === e
                },
                text: function(t) {
                    var e;
                    return "input" === t.nodeName.toLowerCase() && "text" === t.type && (null == (e = t.getAttribute("type")) || "text" === e.toLowerCase())
                },
                first: pt(function() {
                    return [0]
                }),
                last: pt(function(t, e) {
                    return [e - 1]
                }),
                eq: pt(function(t, e, n) {
                    return [0 > n ? n + e : n]
                }),
                even: pt(function(t, e) {
                    for (var n = 0; e > n; n += 2)
                        t.push(n);
                    return t
                }),
                odd: pt(function(t, e) {
                    for (var n = 1; e > n; n += 2)
                        t.push(n);
                    return t
                }),
                lt: pt(function(t, e, n) {
                    for (var i = 0 > n ? n + e : n; --i >= 0; )
                        t.push(i);
                    return t
                }),
                gt: pt(function(t, e, n) {
                    for (var i = 0 > n ? n + e : n; ++i < e; )
                        t.push(i);
                    return t
                })
            }
        }).pseudos.nth = i.pseudos.eq,
        {
            radio: !0,
            checkbox: !0,
            file: !0,
            password: !0,
            image: !0
        })
            i.pseudos[e] = lt(e);
        for (e in {
            submit: !0,
            reset: !0
        })
            i.pseudos[e] = dt(e);
        function ht() {}
        function gt(t) {
            for (var e = 0, n = t.length, i = ""; n > e; e++)
                i += t[e].value;
            return i
        }
        function mt(t, e, n) {
            var i = e.dir
              , r = n && "parentNode" === i
              , o = x++;
            return e.first ? function(e, n, o) {
                for (; e = e[i]; )
                    if (1 === e.nodeType || r)
                        return t(e, n, o)
            }
            : function(e, n, a) {
                var s, c, u, l = [k, o];
                if (a) {
                    for (; e = e[i]; )
                        if ((1 === e.nodeType || r) && t(e, n, a))
                            return !0
                } else
                    for (; e = e[i]; )
                        if (1 === e.nodeType || r) {
                            if ((s = (c = (u = e[P] || (e[P] = {}))[e.uniqueID] || (u[e.uniqueID] = {}))[i]) && s[0] === k && s[1] === o)
                                return l[2] = s[2];
                            if (c[i] = l,
                            l[2] = t(e, n, a))
                                return !0
                        }
            }
        }
        function vt(t) {
            return t.length > 1 ? function(e, n, i) {
                for (var r = t.length; r--; )
                    if (!t[r](e, n, i))
                        return !1;
                return !0
            }
            : t[0]
        }
        function yt(t, e, n, i, r) {
            for (var o, a = [], s = 0, c = t.length, u = null != e; c > s; s++)
                (o = t[s]) && (n && !n(o, i, r) || (a.push(o),
                u && e.push(s)));
            return a
        }
        function bt(t, e, n, i, r, o) {
            return i && !i[P] && (i = bt(i)),
            r && !r[P] && (r = bt(r, o)),
            at(function(o, a, s, c) {
                var u, l, d, p = [], f = [], h = a.length, g = o || function(t, e, n) {
                    for (var i = 0, r = e.length; r > i; i++)
                        rt(t, e[i], n);
                    return n
                }(e || "*", s.nodeType ? [s] : s, []), m = !t || !o && e ? g : yt(g, p, t, s, c), v = n ? r || (o ? t : h || i) ? [] : a : m;
                if (n && n(m, v, s, c),
                i)
                    for (u = yt(v, f),
                    i(u, [], s, c),
                    l = u.length; l--; )
                        (d = u[l]) && (v[f[l]] = !(m[f[l]] = d));
                if (o) {
                    if (r || t) {
                        if (r) {
                            for (u = [],
                            l = v.length; l--; )
                                (d = v[l]) && u.push(m[l] = d);
                            r(null, v = [], u, c)
                        }
                        for (l = v.length; l--; )
                            (d = v[l]) && (u = r ? Q(o, d) : p[l]) > -1 && (o[u] = !(a[u] = d))
                    }
                } else
                    v = yt(v === a ? v.splice(h, v.length) : v),
                    r ? r(null, a, v, c) : D.apply(a, v)
            })
        }
        function Pt(t) {
            for (var e, n, r, o = t.length, a = i.relative[t[0].type], s = a || i.relative[" "], c = a ? 1 : 0, l = mt(function(t) {
                return t === e
            }, s, !0), d = mt(function(t) {
                return Q(e, t) > -1
            }, s, !0), p = [function(t, n, i) {
                var r = !a && (i || n !== u) || ((e = n).nodeType ? l(t, n, i) : d(t, n, i));
                return e = null,
                r
            }
            ]; o > c; c++)
                if (n = i.relative[t[c].type])
                    p = [mt(vt(p), n)];
                else {
                    if ((n = i.filter[t[c].type].apply(null, t[c].matches))[P]) {
                        for (r = ++c; o > r && !i.relative[t[r].type]; r++)
                            ;
                        return bt(c > 1 && vt(p), c > 1 && gt(t.slice(0, c - 1).concat({
                            value: " " === t[c - 2].type ? "*" : ""
                        })).replace(I, "$1"), n, r > c && Pt(t.slice(c, r)), o > r && Pt(t = t.slice(r)), o > r && gt(t))
                    }
                    p.push(n)
                }
            return vt(p)
        }
        function wt(t, e) {
            var n = e.length > 0
              , r = t.length > 0
              , o = function(o, a, s, c, l) {
                var d, h, m, v = 0, y = "0", b = o && [], P = [], w = u, x = o || r && i.find.TAG("*", l), C = k += null == w ? 1 : Math.random() || .1, O = x.length;
                for (l && (u = a === f || a || l); y !== O && null != (d = x[y]); y++) {
                    if (r && d) {
                        for (h = 0,
                        a || d.ownerDocument === f || (p(d),
                        s = !g); m = t[h++]; )
                            if (m(d, a || f, s)) {
                                c.push(d);
                                break
                            }
                        l && (k = C)
                    }
                    n && ((d = !m && d) && v--,
                    o && b.push(d))
                }
                if (v += y,
                n && y !== v) {
                    for (h = 0; m = e[h++]; )
                        m(b, P, a, s);
                    if (o) {
                        if (v > 0)
                            for (; y--; )
                                b[y] || P[y] || (P[y] = F.call(c));
                        P = yt(P)
                    }
                    D.apply(c, P),
                    l && !o && P.length > 0 && v + e.length > 1 && rt.uniqueSort(c)
                }
                return l && (k = C,
                u = w),
                b
            };
            return n ? at(o) : o
        }
        return ht.prototype = i.filters = i.pseudos,
        i.setFilters = new ht,
        a = rt.tokenize = function(t, e) {
            var n, r, o, a, s, c, u, l = O[t + " "];
            if (l)
                return e ? 0 : l.slice(0);
            for (s = t,
            c = [],
            u = i.preFilter; s; ) {
                for (a in n && !(r = $.exec(s)) || (r && (s = s.slice(r[0].length) || s),
                c.push(o = [])),
                n = !1,
                (r = V.exec(s)) && (n = r.shift(),
                o.push({
                    value: n,
                    type: r[0].replace(I, " ")
                }),
                s = s.slice(n.length)),
                i.filter)
                    !(r = X[a].exec(s)) || u[a] && !(r = u[a](r)) || (n = r.shift(),
                    o.push({
                        value: n,
                        type: a,
                        matches: r
                    }),
                    s = s.slice(n.length));
                if (!n)
                    break
            }
            return e ? s.length : s ? rt.error(t) : O(t, c).slice(0)
        }
        ,
        s = rt.compile = function(t, e) {
            var n, i = [], r = [], o = j[t + " "];
            if (!o) {
                for (e || (e = a(t)),
                n = e.length; n--; )
                    (o = Pt(e[n]))[P] ? i.push(o) : r.push(o);
                (o = j(t, wt(r, i))).selector = t
            }
            return o
        }
        ,
        c = rt.select = function(t, e, r, o) {
            var c, u, l, d, p, f = "function" == typeof t && t, h = !o && a(t = f.selector || t);
            if (r = r || [],
            1 === h.length) {
                if ((u = h[0] = h[0].slice(0)).length > 2 && "ID" === (l = u[0]).type && n.getById && 9 === e.nodeType && g && i.relative[u[1].type]) {
                    if (!(e = (i.find.ID(l.matches[0].replace(et, nt), e) || [])[0]))
                        return r;
                    f && (e = e.parentNode),
                    t = t.slice(u.shift().value.length)
                }
                for (c = X.needsContext.test(t) ? 0 : u.length; c-- && (l = u[c],
                !i.relative[d = l.type]); )
                    if ((p = i.find[d]) && (o = p(l.matches[0].replace(et, nt), Z.test(u[0].type) && ft(e.parentNode) || e))) {
                        if (u.splice(c, 1),
                        !(t = o.length && gt(u)))
                            return D.apply(r, o),
                            r;
                        break
                    }
            }
            return (f || s(t, h))(o, e, !g, r, !e || Z.test(t) && ft(e.parentNode) || e),
            r
        }
        ,
        n.sortStable = P.split("").sort(T).join("") === P,
        n.detectDuplicates = !!d,
        p(),
        n.sortDetached = st(function(t) {
            return 1 & t.compareDocumentPosition(f.createElement("div"))
        }),
        st(function(t) {
            return t.innerHTML = "<a href='#'></a>",
            "#" === t.firstChild.getAttribute("href")
        }) || ct("type|href|height|width", function(t, e, n) {
            return n ? void 0 : t.getAttribute(e, "type" === e.toLowerCase() ? 1 : 2)
        }),
        n.attributes && st(function(t) {
            return t.innerHTML = "<input/>",
            t.firstChild.setAttribute("value", ""),
            "" === t.firstChild.getAttribute("value")
        }) || ct("value", function(t, e, n) {
            return n || "input" !== t.nodeName.toLowerCase() ? void 0 : t.defaultValue
        }),
        st(function(t) {
            return null == t.getAttribute("disabled")
        }) || ct(q, function(t, e, n) {
            var i;
            return n ? void 0 : !0 === t[e] ? e.toLowerCase() : (i = t.getAttributeNode(e)) && i.specified ? i.value : null
        }),
        rt
    }(t);
    f.find = b,
    f.expr = b.selectors,
    f.expr[":"] = f.expr.pseudos,
    f.uniqueSort = f.unique = b.uniqueSort,
    f.text = b.getText,
    f.isXMLDoc = b.isXML,
    f.contains = b.contains;
    var P = function(t, e, n) {
        for (var i = [], r = void 0 !== n; (t = t[e]) && 9 !== t.nodeType; )
            if (1 === t.nodeType) {
                if (r && f(t).is(n))
                    break;
                i.push(t)
            }
        return i
    }
      , w = function(t, e) {
        for (var n = []; t; t = t.nextSibling)
            1 === t.nodeType && t !== e && n.push(t);
        return n
    }
      , k = f.expr.match.needsContext
      , x = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/
      , C = /^.[^:#\[\.,]*$/;
    function O(t, e, n) {
        if (f.isFunction(e))
            return f.grep(t, function(t, i) {
                return !!e.call(t, i, t) !== n
            });
        if (e.nodeType)
            return f.grep(t, function(t) {
                return t === e !== n
            });
        if ("string" == typeof e) {
            if (C.test(e))
                return f.filter(e, t, n);
            e = f.filter(e, t)
        }
        return f.grep(t, function(t) {
            return s.call(e, t) > -1 !== n
        })
    }
    f.filter = function(t, e, n) {
        var i = e[0];
        return n && (t = ":not(" + t + ")"),
        1 === e.length && 1 === i.nodeType ? f.find.matchesSelector(i, t) ? [i] : [] : f.find.matches(t, f.grep(e, function(t) {
            return 1 === t.nodeType
        }))
    }
    ,
    f.fn.extend({
        find: function(t) {
            var e, n = this.length, i = [], r = this;
            if ("string" != typeof t)
                return this.pushStack(f(t).filter(function() {
                    for (e = 0; n > e; e++)
                        if (f.contains(r[e], this))
                            return !0
                }));
            for (e = 0; n > e; e++)
                f.find(t, r[e], i);
            return (i = this.pushStack(n > 1 ? f.unique(i) : i)).selector = this.selector ? this.selector + " " + t : t,
            i
        },
        filter: function(t) {
            return this.pushStack(O(this, t || [], !1))
        },
        not: function(t) {
            return this.pushStack(O(this, t || [], !0))
        },
        is: function(t) {
            return !!O(this, "string" == typeof t && k.test(t) ? f(t) : t || [], !1).length
        }
    });
    var j, T = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/;
    (f.fn.init = function(t, e, n) {
        var r, o;
        if (!t)
            return this;
        if (n = n || j,
        "string" == typeof t) {
            if (!(r = "<" === t[0] && ">" === t[t.length - 1] && t.length >= 3 ? [null, t, null] : T.exec(t)) || !r[1] && e)
                return !e || e.jquery ? (e || n).find(t) : this.constructor(e).find(t);
            if (r[1]) {
                if (e = e instanceof f ? e[0] : e,
                f.merge(this, f.parseHTML(r[1], e && e.nodeType ? e.ownerDocument || e : i, !0)),
                x.test(r[1]) && f.isPlainObject(e))
                    for (r in e)
                        f.isFunction(this[r]) ? this[r](e[r]) : this.attr(r, e[r]);
                return this
            }
            return (o = i.getElementById(r[2])) && o.parentNode && (this.length = 1,
            this[0] = o),
            this.context = i,
            this.selector = t,
            this
        }
        return t.nodeType ? (this.context = this[0] = t,
        this.length = 1,
        this) : f.isFunction(t) ? void 0 !== n.ready ? n.ready(t) : t(f) : (void 0 !== t.selector && (this.selector = t.selector,
        this.context = t.context),
        f.makeArray(t, this))
    }
    ).prototype = f.fn,
    j = f(i);
    var _ = /^(?:parents|prev(?:Until|All))/
      , G = {
        children: !0,
        contents: !0,
        next: !0,
        prev: !0
    };
    function S(t, e) {
        for (; (t = t[e]) && 1 !== t.nodeType; )
            ;
        return t
    }
    f.fn.extend({
        has: function(t) {
            var e = f(t, this)
              , n = e.length;
            return this.filter(function() {
                for (var t = 0; n > t; t++)
                    if (f.contains(this, e[t]))
                        return !0
            })
        },
        closest: function(t, e) {
            for (var n, i = 0, r = this.length, o = [], a = k.test(t) || "string" != typeof t ? f(t, e || this.context) : 0; r > i; i++)
                for (n = this[i]; n && n !== e; n = n.parentNode)
                    if (n.nodeType < 11 && (a ? a.index(n) > -1 : 1 === n.nodeType && f.find.matchesSelector(n, t))) {
                        o.push(n);
                        break
                    }
            return this.pushStack(o.length > 1 ? f.uniqueSort(o) : o)
        },
        index: function(t) {
            return t ? "string" == typeof t ? s.call(f(t), this[0]) : s.call(this, t.jquery ? t[0] : t) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
        },
        add: function(t, e) {
            return this.pushStack(f.uniqueSort(f.merge(this.get(), f(t, e))))
        },
        addBack: function(t) {
            return this.add(null == t ? this.prevObject : this.prevObject.filter(t))
        }
    }),
    f.each({
        parent: function(t) {
            var e = t.parentNode;
            return e && 11 !== e.nodeType ? e : null
        },
        parents: function(t) {
            return P(t, "parentNode")
        },
        parentsUntil: function(t, e, n) {
            return P(t, "parentNode", n)
        },
        next: function(t) {
            return S(t, "nextSibling")
        },
        prev: function(t) {
            return S(t, "previousSibling")
        },
        nextAll: function(t) {
            return P(t, "nextSibling")
        },
        prevAll: function(t) {
            return P(t, "previousSibling")
        },
        nextUntil: function(t, e, n) {
            return P(t, "nextSibling", n)
        },
        prevUntil: function(t, e, n) {
            return P(t, "previousSibling", n)
        },
        siblings: function(t) {
            return w((t.parentNode || {}).firstChild, t)
        },
        children: function(t) {
            return w(t.firstChild)
        },
        contents: function(t) {
            return t.contentDocument || f.merge([], t.childNodes)
        }
    }, function(t, e) {
        f.fn[t] = function(n, i) {
            var r = f.map(this, e, n);
            return "Until" !== t.slice(-5) && (i = n),
            i && "string" == typeof i && (r = f.filter(i, r)),
            this.length > 1 && (G[t] || f.uniqueSort(r),
            _.test(t) && r.reverse()),
            this.pushStack(r)
        }
    });
    var F, A = /\S+/g;
    function D() {
        i.removeEventListener("DOMContentLoaded", D),
        t.removeEventListener("load", D),
        f.ready()
    }
    f.Callbacks = function(t) {
        t = "string" == typeof t ? function(t) {
            var e = {};
            return f.each(t.match(A) || [], function(t, n) {
                e[n] = !0
            }),
            e
        }(t) : f.extend({}, t);
        var e, n, i, r, o = [], a = [], s = -1, c = function() {
            for (r = t.once,
            i = e = !0; a.length; s = -1)
                for (n = a.shift(); ++s < o.length; )
                    !1 === o[s].apply(n[0], n[1]) && t.stopOnFalse && (s = o.length,
                    n = !1);
            t.memory || (n = !1),
            e = !1,
            r && (o = n ? [] : "")
        }, u = {
            add: function() {
                return o && (n && !e && (s = o.length - 1,
                a.push(n)),
                function e(n) {
                    f.each(n, function(n, i) {
                        f.isFunction(i) ? t.unique && u.has(i) || o.push(i) : i && i.length && "string" !== f.type(i) && e(i)
                    })
                }(arguments),
                n && !e && c()),
                this
            },
            remove: function() {
                return f.each(arguments, function(t, e) {
                    for (var n; (n = f.inArray(e, o, n)) > -1; )
                        o.splice(n, 1),
                        s >= n && s--
                }),
                this
            },
            has: function(t) {
                return t ? f.inArray(t, o) > -1 : o.length > 0
            },
            empty: function() {
                return o && (o = []),
                this
            },
            disable: function() {
                return r = a = [],
                o = n = "",
                this
            },
            disabled: function() {
                return !o
            },
            lock: function() {
                return r = a = [],
                n || (o = n = ""),
                this
            },
            locked: function() {
                return !!r
            },
            fireWith: function(t, n) {
                return r || (n = [t, (n = n || []).slice ? n.slice() : n],
                a.push(n),
                e || c()),
                this
            },
            fire: function() {
                return u.fireWith(this, arguments),
                this
            },
            fired: function() {
                return !!i
            }
        };
        return u
    }
    ,
    f.extend({
        Deferred: function(t) {
            var e = [["resolve", "done", f.Callbacks("once memory"), "resolved"], ["reject", "fail", f.Callbacks("once memory"), "rejected"], ["notify", "progress", f.Callbacks("memory")]]
              , n = "pending"
              , i = {
                state: function() {
                    return n
                },
                always: function() {
                    return r.done(arguments).fail(arguments),
                    this
                },
                then: function() {
                    var t = arguments;
                    return f.Deferred(function(n) {
                        f.each(e, function(e, o) {
                            var a = f.isFunction(t[e]) && t[e];
                            r[o[1]](function() {
                                var t = a && a.apply(this, arguments);
                                t && f.isFunction(t.promise) ? t.promise().progress(n.notify).done(n.resolve).fail(n.reject) : n[o[0] + "With"](this === i ? n.promise() : this, a ? [t] : arguments)
                            })
                        }),
                        t = null
                    }).promise()
                },
                promise: function(t) {
                    return null != t ? f.extend(t, i) : i
                }
            }
              , r = {};
            return i.pipe = i.then,
            f.each(e, function(t, o) {
                var a = o[2]
                  , s = o[3];
                i[o[1]] = a.add,
                s && a.add(function() {
                    n = s
                }, e[1 ^ t][2].disable, e[2][2].lock),
                r[o[0]] = function() {
                    return r[o[0] + "With"](this === r ? i : this, arguments),
                    this
                }
                ,
                r[o[0] + "With"] = a.fireWith
            }),
            i.promise(r),
            t && t.call(r, r),
            r
        },
        when: function(t) {
            var e, n, i, o = 0, a = r.call(arguments), s = a.length, c = 1 !== s || t && f.isFunction(t.promise) ? s : 0, u = 1 === c ? t : f.Deferred(), l = function(t, n, i) {
                return function(o) {
                    n[t] = this,
                    i[t] = arguments.length > 1 ? r.call(arguments) : o,
                    i === e ? u.notifyWith(n, i) : --c || u.resolveWith(n, i)
                }
            };
            if (s > 1)
                for (e = new Array(s),
                n = new Array(s),
                i = new Array(s); s > o; o++)
                    a[o] && f.isFunction(a[o].promise) ? a[o].promise().progress(l(o, n, e)).done(l(o, i, a)).fail(u.reject) : --c;
            return c || u.resolveWith(i, a),
            u.promise()
        }
    }),
    f.fn.ready = function(t) {
        return f.ready.promise().done(t),
        this
    }
    ,
    f.extend({
        isReady: !1,
        readyWait: 1,
        holdReady: function(t) {
            t ? f.readyWait++ : f.ready(!0)
        },
        ready: function(t) {
            (!0 === t ? --f.readyWait : f.isReady) || (f.isReady = !0,
            !0 !== t && --f.readyWait > 0 || (F.resolveWith(i, [f]),
            f.fn.triggerHandler && (f(i).triggerHandler("ready"),
            f(i).off("ready"))))
        }
    }),
    f.ready.promise = function(e) {
        return F || (F = f.Deferred(),
        "complete" === i.readyState || "loading" !== i.readyState && !i.documentElement.doScroll ? t.setTimeout(f.ready) : (i.addEventListener("DOMContentLoaded", D),
        t.addEventListener("load", D))),
        F.promise(e)
    }
    ,
    f.ready.promise();
    var L = function(t, e, n, i, r, o, a) {
        var s = 0
          , c = t.length
          , u = null == n;
        if ("object" === f.type(n))
            for (s in r = !0,
            n)
                L(t, e, s, n[s], !0, o, a);
        else if (void 0 !== i && (r = !0,
        f.isFunction(i) || (a = !0),
        u && (a ? (e.call(t, i),
        e = null) : (u = e,
        e = function(t, e, n) {
            return u.call(f(t), n)
        }
        )),
        e))
            for (; c > s; s++)
                e(t[s], n, a ? i : i.call(t[s], s, e(t[s], n)));
        return r ? t : u ? e.call(t) : c ? e(t[0], n) : o
    }
      , Q = function(t) {
        return 1 === t.nodeType || 9 === t.nodeType || !+t.nodeType
    };
    function q() {
        this.expando = f.expando + q.uid++
    }
    q.uid = 1,
    q.prototype = {
        register: function(t, e) {
            var n = e || {};
            return t.nodeType ? t[this.expando] = n : Object.defineProperty(t, this.expando, {
                value: n,
                writable: !0,
                configurable: !0
            }),
            t[this.expando]
        },
        cache: function(t) {
            if (!Q(t))
                return {};
            var e = t[this.expando];
            return e || (e = {},
            Q(t) && (t.nodeType ? t[this.expando] = e : Object.defineProperty(t, this.expando, {
                value: e,
                configurable: !0
            }))),
            e
        },
        set: function(t, e, n) {
            var i, r = this.cache(t);
            if ("string" == typeof e)
                r[e] = n;
            else
                for (i in e)
                    r[i] = e[i];
            return r
        },
        get: function(t, e) {
            return void 0 === e ? this.cache(t) : t[this.expando] && t[this.expando][e]
        },
        access: function(t, e, n) {
            var i;
            return void 0 === e || e && "string" == typeof e && void 0 === n ? void 0 !== (i = this.get(t, e)) ? i : this.get(t, f.camelCase(e)) : (this.set(t, e, n),
            void 0 !== n ? n : e)
        },
        remove: function(t, e) {
            var n, i, r, o = t[this.expando];
            if (void 0 !== o) {
                if (void 0 === e)
                    this.register(t);
                else {
                    f.isArray(e) ? i = e.concat(e.map(f.camelCase)) : (r = f.camelCase(e),
                    e in o ? i = [e, r] : i = (i = r)in o ? [i] : i.match(A) || []),
                    n = i.length;
                    for (; n--; )
                        delete o[i[n]]
                }
                (void 0 === e || f.isEmptyObject(o)) && (t.nodeType ? t[this.expando] = void 0 : delete t[this.expando])
            }
        },
        hasData: function(t) {
            var e = t[this.expando];
            return void 0 !== e && !f.isEmptyObject(e)
        }
    };
    var N = new q
      , E = new q
      , M = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/
      , H = /[A-Z]/g;
    function B(t, e, n) {
        var i;
        if (void 0 === n && 1 === t.nodeType)
            if (i = "data-" + e.replace(H, "-$&").toLowerCase(),
            "string" == typeof (n = t.getAttribute(i))) {
                try {
                    n = "true" === n || "false" !== n && ("null" === n ? null : +n + "" === n ? +n : M.test(n) ? f.parseJSON(n) : n)
                } catch (t) {}
                E.set(t, e, n)
            } else
                n = void 0;
        return n
    }
    f.extend({
        hasData: function(t) {
            return E.hasData(t) || N.hasData(t)
        },
        data: function(t, e, n) {
            return E.access(t, e, n)
        },
        removeData: function(t, e) {
            E.remove(t, e)
        },
        _data: function(t, e, n) {
            return N.access(t, e, n)
        },
        _removeData: function(t, e) {
            N.remove(t, e)
        }
    }),
    f.fn.extend({
        data: function(t, e) {
            var n, i, r, o = this[0], a = o && o.attributes;
            if (void 0 === t) {
                if (this.length && (r = E.get(o),
                1 === o.nodeType && !N.get(o, "hasDataAttrs"))) {
                    for (n = a.length; n--; )
                        a[n] && (0 === (i = a[n].name).indexOf("data-") && (i = f.camelCase(i.slice(5)),
                        B(o, i, r[i])));
                    N.set(o, "hasDataAttrs", !0)
                }
                return r
            }
            return "object" == typeof t ? this.each(function() {
                E.set(this, t)
            }) : L(this, function(e) {
                var n, i;
                if (o && void 0 === e) {
                    if (void 0 !== (n = E.get(o, t) || E.get(o, t.replace(H, "-$&").toLowerCase())))
                        return n;
                    if (i = f.camelCase(t),
                    void 0 !== (n = E.get(o, i)))
                        return n;
                    if (void 0 !== (n = B(o, i, void 0)))
                        return n
                } else
                    i = f.camelCase(t),
                    this.each(function() {
                        var n = E.get(this, i);
                        E.set(this, i, e),
                        t.indexOf("-") > -1 && void 0 !== n && E.set(this, t, e)
                    })
            }, null, e, arguments.length > 1, null, !0)
        },
        removeData: function(t) {
            return this.each(function() {
                E.remove(this, t)
            })
        }
    }),
    f.extend({
        queue: function(t, e, n) {
            var i;
            return t ? (e = (e || "fx") + "queue",
            i = N.get(t, e),
            n && (!i || f.isArray(n) ? i = N.access(t, e, f.makeArray(n)) : i.push(n)),
            i || []) : void 0
        },
        dequeue: function(t, e) {
            e = e || "fx";
            var n = f.queue(t, e)
              , i = n.length
              , r = n.shift()
              , o = f._queueHooks(t, e);
            "inprogress" === r && (r = n.shift(),
            i--),
            r && ("fx" === e && n.unshift("inprogress"),
            delete o.stop,
            r.call(t, function() {
                f.dequeue(t, e)
            }, o)),
            !i && o && o.empty.fire()
        },
        _queueHooks: function(t, e) {
            var n = e + "queueHooks";
            return N.get(t, n) || N.access(t, n, {
                empty: f.Callbacks("once memory").add(function() {
                    N.remove(t, [e + "queue", n])
                })
            })
        }
    }),
    f.fn.extend({
        queue: function(t, e) {
            var n = 2;
            return "string" != typeof t && (e = t,
            t = "fx",
            n--),
            arguments.length < n ? f.queue(this[0], t) : void 0 === e ? this : this.each(function() {
                var n = f.queue(this, t, e);
                f._queueHooks(this, t),
                "fx" === t && "inprogress" !== n[0] && f.dequeue(this, t)
            })
        },
        dequeue: function(t) {
            return this.each(function() {
                f.dequeue(this, t)
            })
        },
        clearQueue: function(t) {
            return this.queue(t || "fx", [])
        },
        promise: function(t, e) {
            var n, i = 1, r = f.Deferred(), o = this, a = this.length, s = function() {
                --i || r.resolveWith(o, [o])
            };
            for ("string" != typeof t && (e = t,
            t = void 0),
            t = t || "fx"; a--; )
                (n = N.get(o[a], t + "queueHooks")) && n.empty && (i++,
                n.empty.add(s));
            return s(),
            r.promise(e)
        }
    });
    var I = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source
      , $ = new RegExp("^(?:([+-])=|)(" + I + ")([a-z%]*)$","i")
      , V = ["Top", "Right", "Bottom", "Left"]
      , R = function(t, e) {
        return t = e || t,
        "none" === f.css(t, "display") || !f.contains(t.ownerDocument, t)
    };
    function W(t, e, n, i) {
        var r, o = 1, a = 20, s = i ? function() {
            return i.cur()
        }
        : function() {
            return f.css(t, e, "")
        }
        , c = s(), u = n && n[3] || (f.cssNumber[e] ? "" : "px"), l = (f.cssNumber[e] || "px" !== u && +c) && $.exec(f.css(t, e));
        if (l && l[3] !== u) {
            u = u || l[3],
            n = n || [],
            l = +c || 1;
            do {
                l /= o = o || ".5",
                f.style(t, e, l + u)
            } while (o !== (o = s() / c) && 1 !== o && --a)
        }
        return n && (l = +l || +c || 0,
        r = n[1] ? l + (n[1] + 1) * n[2] : +n[2],
        i && (i.unit = u,
        i.start = l,
        i.end = r)),
        r
    }
    var z = /^(?:checkbox|radio)$/i
      , X = /<([\w:-]+)/
      , U = /^$|\/(?:java|ecma)script/i
      , Y = {
        option: [1, "<select multiple='multiple'>", "</select>"],
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""]
    };
    function J(t, e) {
        var n = void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e || "*") : void 0 !== t.querySelectorAll ? t.querySelectorAll(e || "*") : [];
        return void 0 === e || e && f.nodeName(t, e) ? f.merge([t], n) : n
    }
    function K(t, e) {
        for (var n = 0, i = t.length; i > n; n++)
            N.set(t[n], "globalEval", !e || N.get(e[n], "globalEval"))
    }
    Y.optgroup = Y.option,
    Y.tbody = Y.tfoot = Y.colgroup = Y.caption = Y.thead,
    Y.th = Y.td;
    var Z = /<|&#?\w+;/;
    function tt(t, e, n, i, r) {
        for (var o, a, s, c, u, l, d = e.createDocumentFragment(), p = [], h = 0, g = t.length; g > h; h++)
            if ((o = t[h]) || 0 === o)
                if ("object" === f.type(o))
                    f.merge(p, o.nodeType ? [o] : o);
                else if (Z.test(o)) {
                    for (a = a || d.appendChild(e.createElement("div")),
                    s = (X.exec(o) || ["", ""])[1].toLowerCase(),
                    c = Y[s] || Y._default,
                    a.innerHTML = c[1] + f.htmlPrefilter(o) + c[2],
                    l = c[0]; l--; )
                        a = a.lastChild;
                    f.merge(p, a.childNodes),
                    (a = d.firstChild).textContent = ""
                } else
                    p.push(e.createTextNode(o));
        for (d.textContent = "",
        h = 0; o = p[h++]; )
            if (i && f.inArray(o, i) > -1)
                r && r.push(o);
            else if (u = f.contains(o.ownerDocument, o),
            a = J(d.appendChild(o), "script"),
            u && K(a),
            n)
                for (l = 0; o = a[l++]; )
                    U.test(o.type || "") && n.push(o);
        return d
    }
    !function() {
        var t = i.createDocumentFragment().appendChild(i.createElement("div"))
          , e = i.createElement("input");
        e.setAttribute("type", "radio"),
        e.setAttribute("checked", "checked"),
        e.setAttribute("name", "t"),
        t.appendChild(e),
        d.checkClone = t.cloneNode(!0).cloneNode(!0).lastChild.checked,
        t.innerHTML = "<textarea>x</textarea>",
        d.noCloneChecked = !!t.cloneNode(!0).lastChild.defaultValue
    }();
    var et = /^key/
      , nt = /^(?:mouse|pointer|contextmenu|drag|drop)|click/
      , it = /^([^.]*)(?:\.(.+)|)/;
    function rt() {
        return !0
    }
    function ot() {
        return !1
    }
    function at() {
        try {
            return i.activeElement
        } catch (t) {}
    }
    function st(t, e, n, i, r, o) {
        var a, s;
        if ("object" == typeof e) {
            for (s in "string" != typeof n && (i = i || n,
            n = void 0),
            e)
                st(t, s, n, i, e[s], o);
            return t
        }
        if (null == i && null == r ? (r = n,
        i = n = void 0) : null == r && ("string" == typeof n ? (r = i,
        i = void 0) : (r = i,
        i = n,
        n = void 0)),
        !1 === r)
            r = ot;
        else if (!r)
            return t;
        return 1 === o && (a = r,
        (r = function(t) {
            return f().off(t),
            a.apply(this, arguments)
        }
        ).guid = a.guid || (a.guid = f.guid++)),
        t.each(function() {
            f.event.add(this, e, r, i, n)
        })
    }
    f.event = {
        global: {},
        add: function(t, e, n, i, r) {
            var o, a, s, c, u, l, d, p, h, g, m, v = N.get(t);
            if (v)
                for (n.handler && (n = (o = n).handler,
                r = o.selector),
                n.guid || (n.guid = f.guid++),
                (c = v.events) || (c = v.events = {}),
                (a = v.handle) || (a = v.handle = function(e) {
                    return void 0 !== f && f.event.triggered !== e.type ? f.event.dispatch.apply(t, arguments) : void 0
                }
                ),
                u = (e = (e || "").match(A) || [""]).length; u--; )
                    h = m = (s = it.exec(e[u]) || [])[1],
                    g = (s[2] || "").split(".").sort(),
                    h && (d = f.event.special[h] || {},
                    h = (r ? d.delegateType : d.bindType) || h,
                    d = f.event.special[h] || {},
                    l = f.extend({
                        type: h,
                        origType: m,
                        data: i,
                        handler: n,
                        guid: n.guid,
                        selector: r,
                        needsContext: r && f.expr.match.needsContext.test(r),
                        namespace: g.join(".")
                    }, o),
                    (p = c[h]) || ((p = c[h] = []).delegateCount = 0,
                    d.setup && !1 !== d.setup.call(t, i, g, a) || t.addEventListener && t.addEventListener(h, a)),
                    d.add && (d.add.call(t, l),
                    l.handler.guid || (l.handler.guid = n.guid)),
                    r ? p.splice(p.delegateCount++, 0, l) : p.push(l),
                    f.event.global[h] = !0)
        },
        remove: function(t, e, n, i, r) {
            var o, a, s, c, u, l, d, p, h, g, m, v = N.hasData(t) && N.get(t);
            if (v && (c = v.events)) {
                for (u = (e = (e || "").match(A) || [""]).length; u--; )
                    if (h = m = (s = it.exec(e[u]) || [])[1],
                    g = (s[2] || "").split(".").sort(),
                    h) {
                        for (d = f.event.special[h] || {},
                        p = c[h = (i ? d.delegateType : d.bindType) || h] || [],
                        s = s[2] && new RegExp("(^|\\.)" + g.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                        a = o = p.length; o--; )
                            l = p[o],
                            !r && m !== l.origType || n && n.guid !== l.guid || s && !s.test(l.namespace) || i && i !== l.selector && ("**" !== i || !l.selector) || (p.splice(o, 1),
                            l.selector && p.delegateCount--,
                            d.remove && d.remove.call(t, l));
                        a && !p.length && (d.teardown && !1 !== d.teardown.call(t, g, v.handle) || f.removeEvent(t, h, v.handle),
                        delete c[h])
                    } else
                        for (h in c)
                            f.event.remove(t, h + e[u], n, i, !0);
                f.isEmptyObject(c) && N.remove(t, "handle events")
            }
        },
        dispatch: function(t) {
            t = f.event.fix(t);
            var e, n, i, o, a, s = [], c = r.call(arguments), u = (N.get(this, "events") || {})[t.type] || [], l = f.event.special[t.type] || {};
            if (c[0] = t,
            t.delegateTarget = this,
            !l.preDispatch || !1 !== l.preDispatch.call(this, t)) {
                for (s = f.event.handlers.call(this, t, u),
                e = 0; (o = s[e++]) && !t.isPropagationStopped(); )
                    for (t.currentTarget = o.elem,
                    n = 0; (a = o.handlers[n++]) && !t.isImmediatePropagationStopped(); )
                        t.rnamespace && !t.rnamespace.test(a.namespace) || (t.handleObj = a,
                        t.data = a.data,
                        void 0 !== (i = ((f.event.special[a.origType] || {}).handle || a.handler).apply(o.elem, c)) && !1 === (t.result = i) && (t.preventDefault(),
                        t.stopPropagation()));
                return l.postDispatch && l.postDispatch.call(this, t),
                t.result
            }
        },
        handlers: function(t, e) {
            var n, i, r, o, a = [], s = e.delegateCount, c = t.target;
            if (s && c.nodeType && ("click" !== t.type || isNaN(t.button) || t.button < 1))
                for (; c !== this; c = c.parentNode || this)
                    if (1 === c.nodeType && (!0 !== c.disabled || "click" !== t.type)) {
                        for (i = [],
                        n = 0; s > n; n++)
                            void 0 === i[r = (o = e[n]).selector + " "] && (i[r] = o.needsContext ? f(r, this).index(c) > -1 : f.find(r, this, null, [c]).length),
                            i[r] && i.push(o);
                        i.length && a.push({
                            elem: c,
                            handlers: i
                        })
                    }
            return s < e.length && a.push({
                elem: this,
                handlers: e.slice(s)
            }),
            a
        },
        props: "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
        fixHooks: {},
        keyHooks: {
            props: "char charCode key keyCode".split(" "),
            filter: function(t, e) {
                return null == t.which && (t.which = null != e.charCode ? e.charCode : e.keyCode),
                t
            }
        },
        mouseHooks: {
            props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
            filter: function(t, e) {
                var n, r, o, a = e.button;
                return null == t.pageX && null != e.clientX && (r = (n = t.target.ownerDocument || i).documentElement,
                o = n.body,
                t.pageX = e.clientX + (r && r.scrollLeft || o && o.scrollLeft || 0) - (r && r.clientLeft || o && o.clientLeft || 0),
                t.pageY = e.clientY + (r && r.scrollTop || o && o.scrollTop || 0) - (r && r.clientTop || o && o.clientTop || 0)),
                t.which || void 0 === a || (t.which = 1 & a ? 1 : 2 & a ? 3 : 4 & a ? 2 : 0),
                t
            }
        },
        fix: function(t) {
            if (t[f.expando])
                return t;
            var e, n, r, o = t.type, a = t, s = this.fixHooks[o];
            for (s || (this.fixHooks[o] = s = nt.test(o) ? this.mouseHooks : et.test(o) ? this.keyHooks : {}),
            r = s.props ? this.props.concat(s.props) : this.props,
            t = new f.Event(a),
            e = r.length; e--; )
                t[n = r[e]] = a[n];
            return t.target || (t.target = i),
            3 === t.target.nodeType && (t.target = t.target.parentNode),
            s.filter ? s.filter(t, a) : t
        },
        special: {
            load: {
                noBubble: !0
            },
            focus: {
                trigger: function() {
                    return this !== at() && this.focus ? (this.focus(),
                    !1) : void 0
                },
                delegateType: "focusin"
            },
            blur: {
                trigger: function() {
                    return this === at() && this.blur ? (this.blur(),
                    !1) : void 0
                },
                delegateType: "focusout"
            },
            click: {
                trigger: function() {
                    return "checkbox" === this.type && this.click && f.nodeName(this, "input") ? (this.click(),
                    !1) : void 0
                },
                _default: function(t) {
                    return f.nodeName(t.target, "a")
                }
            },
            beforeunload: {
                postDispatch: function(t) {
                    void 0 !== t.result && t.originalEvent && (t.originalEvent.returnValue = t.result)
                }
            }
        }
    },
    f.removeEvent = function(t, e, n) {
        t.removeEventListener && t.removeEventListener(e, n)
    }
    ,
    f.Event = function(t, e) {
        return this instanceof f.Event ? (t && t.type ? (this.originalEvent = t,
        this.type = t.type,
        this.isDefaultPrevented = t.defaultPrevented || void 0 === t.defaultPrevented && !1 === t.returnValue ? rt : ot) : this.type = t,
        e && f.extend(this, e),
        this.timeStamp = t && t.timeStamp || f.now(),
        void (this[f.expando] = !0)) : new f.Event(t,e)
    }
    ,
    f.Event.prototype = {
        constructor: f.Event,
        isDefaultPrevented: ot,
        isPropagationStopped: ot,
        isImmediatePropagationStopped: ot,
        preventDefault: function() {
            var t = this.originalEvent;
            this.isDefaultPrevented = rt,
            t && t.preventDefault()
        },
        stopPropagation: function() {
            var t = this.originalEvent;
            this.isPropagationStopped = rt,
            t && t.stopPropagation()
        },
        stopImmediatePropagation: function() {
            var t = this.originalEvent;
            this.isImmediatePropagationStopped = rt,
            t && t.stopImmediatePropagation(),
            this.stopPropagation()
        }
    },
    f.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(t, e) {
        f.event.special[t] = {
            delegateType: e,
            bindType: e,
            handle: function(t) {
                var n, i = t.relatedTarget, r = t.handleObj;
                return i && (i === this || f.contains(this, i)) || (t.type = r.origType,
                n = r.handler.apply(this, arguments),
                t.type = e),
                n
            }
        }
    }),
    f.fn.extend({
        on: function(t, e, n, i) {
            return st(this, t, e, n, i)
        },
        one: function(t, e, n, i) {
            return st(this, t, e, n, i, 1)
        },
        off: function(t, e, n) {
            var i, r;
            if (t && t.preventDefault && t.handleObj)
                return i = t.handleObj,
                f(t.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler),
                this;
            if ("object" == typeof t) {
                for (r in t)
                    this.off(r, e, t[r]);
                return this
            }
            return !1 !== e && "function" != typeof e || (n = e,
            e = void 0),
            !1 === n && (n = ot),
            this.each(function() {
                f.event.remove(this, t, n, e)
            })
        }
    });
    var ct = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi
      , ut = /<script|<style|<link/i
      , lt = /checked\s*(?:[^=]|=\s*.checked.)/i
      , dt = /^true\/(.*)/
      , pt = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    function ft(t, e) {
        return f.nodeName(t, "table") && f.nodeName(11 !== e.nodeType ? e : e.firstChild, "tr") ? t.getElementsByTagName("tbody")[0] || t.appendChild(t.ownerDocument.createElement("tbody")) : t
    }
    function ht(t) {
        return t.type = (null !== t.getAttribute("type")) + "/" + t.type,
        t
    }
    function gt(t) {
        var e = dt.exec(t.type);
        return e ? t.type = e[1] : t.removeAttribute("type"),
        t
    }
    function mt(t, e) {
        var n, i, r, o, a, s, c, u;
        if (1 === e.nodeType) {
            if (N.hasData(t) && (o = N.access(t),
            a = N.set(e, o),
            u = o.events))
                for (r in delete a.handle,
                a.events = {},
                u)
                    for (n = 0,
                    i = u[r].length; i > n; n++)
                        f.event.add(e, r, u[r][n]);
            E.hasData(t) && (s = E.access(t),
            c = f.extend({}, s),
            E.set(e, c))
        }
    }
    function vt(t, e) {
        var n = e.nodeName.toLowerCase();
        "input" === n && z.test(t.type) ? e.checked = t.checked : "input" !== n && "textarea" !== n || (e.defaultValue = t.defaultValue)
    }
    function yt(t, e, n, i) {
        e = o.apply([], e);
        var r, a, s, c, u, l, p = 0, h = t.length, g = h - 1, m = e[0], v = f.isFunction(m);
        if (v || h > 1 && "string" == typeof m && !d.checkClone && lt.test(m))
            return t.each(function(r) {
                var o = t.eq(r);
                v && (e[0] = m.call(this, r, o.html())),
                yt(o, e, n, i)
            });
        if (h && (a = (r = tt(e, t[0].ownerDocument, !1, t, i)).firstChild,
        1 === r.childNodes.length && (r = a),
        a || i)) {
            for (c = (s = f.map(J(r, "script"), ht)).length; h > p; p++)
                u = r,
                p !== g && (u = f.clone(u, !0, !0),
                c && f.merge(s, J(u, "script"))),
                n.call(t[p], u, p);
            if (c)
                for (l = s[s.length - 1].ownerDocument,
                f.map(s, gt),
                p = 0; c > p; p++)
                    u = s[p],
                    U.test(u.type || "") && !N.access(u, "globalEval") && f.contains(l, u) && (u.src ? f._evalUrl && f._evalUrl(u.src) : f.globalEval(u.textContent.replace(pt, "")))
        }
        return t
    }
    function bt(t, e, n) {
        for (var i, r = e ? f.filter(e, t) : t, o = 0; null != (i = r[o]); o++)
            n || 1 !== i.nodeType || f.cleanData(J(i)),
            i.parentNode && (n && f.contains(i.ownerDocument, i) && K(J(i, "script")),
            i.parentNode.removeChild(i));
        return t
    }
    f.extend({
        htmlPrefilter: function(t) {
            return t.replace(ct, "<$1></$2>")
        },
        clone: function(t, e, n) {
            var i, r, o, a, s = t.cloneNode(!0), c = f.contains(t.ownerDocument, t);
            if (!(d.noCloneChecked || 1 !== t.nodeType && 11 !== t.nodeType || f.isXMLDoc(t)))
                for (a = J(s),
                i = 0,
                r = (o = J(t)).length; r > i; i++)
                    vt(o[i], a[i]);
            if (e)
                if (n)
                    for (o = o || J(t),
                    a = a || J(s),
                    i = 0,
                    r = o.length; r > i; i++)
                        mt(o[i], a[i]);
                else
                    mt(t, s);
            return (a = J(s, "script")).length > 0 && K(a, !c && J(t, "script")),
            s
        },
        cleanData: function(t) {
            for (var e, n, i, r = f.event.special, o = 0; void 0 !== (n = t[o]); o++)
                if (Q(n)) {
                    if (e = n[N.expando]) {
                        if (e.events)
                            for (i in e.events)
                                r[i] ? f.event.remove(n, i) : f.removeEvent(n, i, e.handle);
                        n[N.expando] = void 0
                    }
                    n[E.expando] && (n[E.expando] = void 0)
                }
        }
    }),
    f.fn.extend({
        domManip: yt,
        detach: function(t) {
            return bt(this, t, !0)
        },
        remove: function(t) {
            return bt(this, t)
        },
        text: function(t) {
            return L(this, function(t) {
                return void 0 === t ? f.text(this) : this.empty().each(function() {
                    1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = t)
                })
            }, null, t, arguments.length)
        },
        append: function() {
            return yt(this, arguments, function(t) {
                1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || ft(this, t).appendChild(t)
            })
        },
        prepend: function() {
            return yt(this, arguments, function(t) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var e = ft(this, t);
                    e.insertBefore(t, e.firstChild)
                }
            })
        },
        before: function() {
            return yt(this, arguments, function(t) {
                this.parentNode && this.parentNode.insertBefore(t, this)
            })
        },
        after: function() {
            return yt(this, arguments, function(t) {
                this.parentNode && this.parentNode.insertBefore(t, this.nextSibling)
            })
        },
        empty: function() {
            for (var t, e = 0; null != (t = this[e]); e++)
                1 === t.nodeType && (f.cleanData(J(t, !1)),
                t.textContent = "");
            return this
        },
        clone: function(t, e) {
            return t = null != t && t,
            e = null == e ? t : e,
            this.map(function() {
                return f.clone(this, t, e)
            })
        },
        html: function(t) {
            return L(this, function(t) {
                var e = this[0] || {}
                  , n = 0
                  , i = this.length;
                if (void 0 === t && 1 === e.nodeType)
                    return e.innerHTML;
                if ("string" == typeof t && !ut.test(t) && !Y[(X.exec(t) || ["", ""])[1].toLowerCase()]) {
                    t = f.htmlPrefilter(t);
                    try {
                        for (; i > n; n++)
                            1 === (e = this[n] || {}).nodeType && (f.cleanData(J(e, !1)),
                            e.innerHTML = t);
                        e = 0
                    } catch (t) {}
                }
                e && this.empty().append(t)
            }, null, t, arguments.length)
        },
        replaceWith: function() {
            var t = [];
            return yt(this, arguments, function(e) {
                var n = this.parentNode;
                f.inArray(this, t) < 0 && (f.cleanData(J(this)),
                n && n.replaceChild(e, this))
            }, t)
        }
    }),
    f.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(t, e) {
        f.fn[t] = function(t) {
            for (var n, i = [], r = f(t), o = r.length - 1, s = 0; o >= s; s++)
                n = s === o ? this : this.clone(!0),
                f(r[s])[e](n),
                a.apply(i, n.get());
            return this.pushStack(i)
        }
    });
    var Pt, wt = {
        HTML: "block",
        BODY: "block"
    };
    function kt(t, e) {
        var n = f(e.createElement(t)).appendTo(e.body)
          , i = f.css(n[0], "display");
        return n.detach(),
        i
    }
    function xt(t) {
        var e = i
          , n = wt[t];
        return n || ("none" !== (n = kt(t, e)) && n || ((e = (Pt = (Pt || f("<iframe frameborder='0' width='0' height='0'/>")).appendTo(e.documentElement))[0].contentDocument).write(),
        e.close(),
        n = kt(t, e),
        Pt.detach()),
        wt[t] = n),
        n
    }
    var Ct = /^margin/
      , Ot = new RegExp("^(" + I + ")(?!px)[a-z%]+$","i")
      , jt = function(e) {
        var n = e.ownerDocument.defaultView;
        return n && n.opener || (n = t),
        n.getComputedStyle(e)
    }
      , Tt = function(t, e, n, i) {
        var r, o, a = {};
        for (o in e)
            a[o] = t.style[o],
            t.style[o] = e[o];
        for (o in r = n.apply(t, i || []),
        e)
            t.style[o] = a[o];
        return r
    }
      , _t = i.documentElement;
    function Gt(t, e, n) {
        var i, r, o, a, s = t.style;
        return "" !== (a = (n = n || jt(t)) ? n.getPropertyValue(e) || n[e] : void 0) && void 0 !== a || f.contains(t.ownerDocument, t) || (a = f.style(t, e)),
        n && !d.pixelMarginRight() && Ot.test(a) && Ct.test(e) && (i = s.width,
        r = s.minWidth,
        o = s.maxWidth,
        s.minWidth = s.maxWidth = s.width = a,
        a = n.width,
        s.width = i,
        s.minWidth = r,
        s.maxWidth = o),
        void 0 !== a ? a + "" : a
    }
    function St(t, e) {
        return {
            get: function() {
                return t() ? void delete this.get : (this.get = e).apply(this, arguments)
            }
        }
    }
    !function() {
        var e, n, r, o, a = i.createElement("div"), s = i.createElement("div");
        if (s.style) {
            function c() {
                s.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%",
                s.innerHTML = "",
                _t.appendChild(a);
                var i = t.getComputedStyle(s);
                e = "1%" !== i.top,
                o = "2px" === i.marginLeft,
                n = "4px" === i.width,
                s.style.marginRight = "50%",
                r = "4px" === i.marginRight,
                _t.removeChild(a)
            }
            s.style.backgroundClip = "content-box",
            s.cloneNode(!0).style.backgroundClip = "",
            d.clearCloneStyle = "content-box" === s.style.backgroundClip,
            a.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute",
            a.appendChild(s),
            f.extend(d, {
                pixelPosition: function() {
                    return c(),
                    e
                },
                boxSizingReliable: function() {
                    return null == n && c(),
                    n
                },
                pixelMarginRight: function() {
                    return null == n && c(),
                    r
                },
                reliableMarginLeft: function() {
                    return null == n && c(),
                    o
                },
                reliableMarginRight: function() {
                    var e, n = s.appendChild(i.createElement("div"));
                    return n.style.cssText = s.style.cssText = "-webkit-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0",
                    n.style.marginRight = n.style.width = "0",
                    s.style.width = "1px",
                    _t.appendChild(a),
                    e = !parseFloat(t.getComputedStyle(n).marginRight),
                    _t.removeChild(a),
                    s.removeChild(n),
                    e
                }
            })
        }
    }();
    var Ft = /^(none|table(?!-c[ea]).+)/
      , At = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }
      , Dt = {
        letterSpacing: "0",
        fontWeight: "400"
    }
      , Lt = ["Webkit", "O", "Moz", "ms"]
      , Qt = i.createElement("div").style;
    function qt(t) {
        if (t in Qt)
            return t;
        for (var e = t[0].toUpperCase() + t.slice(1), n = Lt.length; n--; )
            if ((t = Lt[n] + e)in Qt)
                return t
    }
    function Nt(t, e, n) {
        var i = $.exec(e);
        return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || "px") : e
    }
    function Et(t, e, n, i, r) {
        for (var o = n === (i ? "border" : "content") ? 4 : "width" === e ? 1 : 0, a = 0; 4 > o; o += 2)
            "margin" === n && (a += f.css(t, n + V[o], !0, r)),
            i ? ("content" === n && (a -= f.css(t, "padding" + V[o], !0, r)),
            "margin" !== n && (a -= f.css(t, "border" + V[o] + "Width", !0, r))) : (a += f.css(t, "padding" + V[o], !0, r),
            "padding" !== n && (a += f.css(t, "border" + V[o] + "Width", !0, r)));
        return a
    }
    function Mt(e, n, r) {
        var o = !0
          , a = "width" === n ? e.offsetWidth : e.offsetHeight
          , s = jt(e)
          , c = "border-box" === f.css(e, "boxSizing", !1, s);
        if (i.msFullscreenElement && t.top !== t && e.getClientRects().length && (a = Math.round(100 * e.getBoundingClientRect()[n])),
        0 >= a || null == a) {
            if ((0 > (a = Gt(e, n, s)) || null == a) && (a = e.style[n]),
            Ot.test(a))
                return a;
            o = c && (d.boxSizingReliable() || a === e.style[n]),
            a = parseFloat(a) || 0
        }
        return a + Et(e, n, r || (c ? "border" : "content"), o, s) + "px"
    }
    function Ht(t, e) {
        for (var n, i, r, o = [], a = 0, s = t.length; s > a; a++)
            (i = t[a]).style && (o[a] = N.get(i, "olddisplay"),
            n = i.style.display,
            e ? (o[a] || "none" !== n || (i.style.display = ""),
            "" === i.style.display && R(i) && (o[a] = N.access(i, "olddisplay", xt(i.nodeName)))) : (r = R(i),
            "none" === n && r || N.set(i, "olddisplay", r ? n : f.css(i, "display"))));
        for (a = 0; s > a; a++)
            (i = t[a]).style && (e && "none" !== i.style.display && "" !== i.style.display || (i.style.display = e ? o[a] || "" : "none"));
        return t
    }
    function Bt(t, e, n, i, r) {
        return new Bt.prototype.init(t,e,n,i,r)
    }
    f.extend({
        cssHooks: {
            opacity: {
                get: function(t, e) {
                    if (e) {
                        var n = Gt(t, "opacity");
                        return "" === n ? "1" : n
                    }
                }
            }
        },
        cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0
        },
        cssProps: {
            float: "cssFloat"
        },
        style: function(t, e, n, i) {
            if (t && 3 !== t.nodeType && 8 !== t.nodeType && t.style) {
                var r, o, a, s = f.camelCase(e), c = t.style;
                return e = f.cssProps[s] || (f.cssProps[s] = qt(s) || s),
                a = f.cssHooks[e] || f.cssHooks[s],
                void 0 === n ? a && "get"in a && void 0 !== (r = a.get(t, !1, i)) ? r : c[e] : ("string" === (o = typeof n) && (r = $.exec(n)) && r[1] && (n = W(t, e, r),
                o = "number"),
                void (null != n && n == n && ("number" === o && (n += r && r[3] || (f.cssNumber[s] ? "" : "px")),
                d.clearCloneStyle || "" !== n || 0 !== e.indexOf("background") || (c[e] = "inherit"),
                a && "set"in a && void 0 === (n = a.set(t, n, i)) || (c[e] = n))))
            }
        },
        css: function(t, e, n, i) {
            var r, o, a, s = f.camelCase(e);
            return e = f.cssProps[s] || (f.cssProps[s] = qt(s) || s),
            (a = f.cssHooks[e] || f.cssHooks[s]) && "get"in a && (r = a.get(t, !0, n)),
            void 0 === r && (r = Gt(t, e, i)),
            "normal" === r && e in Dt && (r = Dt[e]),
            "" === n || n ? (o = parseFloat(r),
            !0 === n || isFinite(o) ? o || 0 : r) : r
        }
    }),
    f.each(["height", "width"], function(t, e) {
        f.cssHooks[e] = {
            get: function(t, n, i) {
                return n ? Ft.test(f.css(t, "display")) && 0 === t.offsetWidth ? Tt(t, At, function() {
                    return Mt(t, e, i)
                }) : Mt(t, e, i) : void 0
            },
            set: function(t, n, i) {
                var r, o = i && jt(t), a = i && Et(t, e, i, "border-box" === f.css(t, "boxSizing", !1, o), o);
                return a && (r = $.exec(n)) && "px" !== (r[3] || "px") && (t.style[e] = n,
                n = f.css(t, e)),
                Nt(0, n, a)
            }
        }
    }),
    f.cssHooks.marginLeft = St(d.reliableMarginLeft, function(t, e) {
        return e ? (parseFloat(Gt(t, "marginLeft")) || t.getBoundingClientRect().left - Tt(t, {
            marginLeft: 0
        }, function() {
            return t.getBoundingClientRect().left
        })) + "px" : void 0
    }),
    f.cssHooks.marginRight = St(d.reliableMarginRight, function(t, e) {
        return e ? Tt(t, {
            display: "inline-block"
        }, Gt, [t, "marginRight"]) : void 0
    }),
    f.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(t, e) {
        f.cssHooks[t + e] = {
            expand: function(n) {
                for (var i = 0, r = {}, o = "string" == typeof n ? n.split(" ") : [n]; 4 > i; i++)
                    r[t + V[i] + e] = o[i] || o[i - 2] || o[0];
                return r
            }
        },
        Ct.test(t) || (f.cssHooks[t + e].set = Nt)
    }),
    f.fn.extend({
        css: function(t, e) {
            return L(this, function(t, e, n) {
                var i, r, o = {}, a = 0;
                if (f.isArray(e)) {
                    for (i = jt(t),
                    r = e.length; r > a; a++)
                        o[e[a]] = f.css(t, e[a], !1, i);
                    return o
                }
                return void 0 !== n ? f.style(t, e, n) : f.css(t, e)
            }, t, e, arguments.length > 1)
        },
        show: function() {
            return Ht(this, !0)
        },
        hide: function() {
            return Ht(this)
        },
        toggle: function(t) {
            return "boolean" == typeof t ? t ? this.show() : this.hide() : this.each(function() {
                R(this) ? f(this).show() : f(this).hide()
            })
        }
    }),
    f.Tween = Bt,
    Bt.prototype = {
        constructor: Bt,
        init: function(t, e, n, i, r, o) {
            this.elem = t,
            this.prop = n,
            this.easing = r || f.easing._default,
            this.options = e,
            this.start = this.now = this.cur(),
            this.end = i,
            this.unit = o || (f.cssNumber[n] ? "" : "px")
        },
        cur: function() {
            var t = Bt.propHooks[this.prop];
            return t && t.get ? t.get(this) : Bt.propHooks._default.get(this)
        },
        run: function(t) {
            var e, n = Bt.propHooks[this.prop];
            return this.options.duration ? this.pos = e = f.easing[this.easing](t, this.options.duration * t, 0, 1, this.options.duration) : this.pos = e = t,
            this.now = (this.end - this.start) * e + this.start,
            this.options.step && this.options.step.call(this.elem, this.now, this),
            n && n.set ? n.set(this) : Bt.propHooks._default.set(this),
            this
        }
    },
    Bt.prototype.init.prototype = Bt.prototype,
    Bt.propHooks = {
        _default: {
            get: function(t) {
                var e;
                return 1 !== t.elem.nodeType || null != t.elem[t.prop] && null == t.elem.style[t.prop] ? t.elem[t.prop] : (e = f.css(t.elem, t.prop, "")) && "auto" !== e ? e : 0
            },
            set: function(t) {
                f.fx.step[t.prop] ? f.fx.step[t.prop](t) : 1 !== t.elem.nodeType || null == t.elem.style[f.cssProps[t.prop]] && !f.cssHooks[t.prop] ? t.elem[t.prop] = t.now : f.style(t.elem, t.prop, t.now + t.unit)
            }
        }
    },
    Bt.propHooks.scrollTop = Bt.propHooks.scrollLeft = {
        set: function(t) {
            t.elem.nodeType && t.elem.parentNode && (t.elem[t.prop] = t.now)
        }
    },
    f.easing = {
        linear: function(t) {
            return t
        },
        swing: function(t) {
            return .5 - Math.cos(t * Math.PI) / 2
        },
        _default: "swing"
    },
    f.fx = Bt.prototype.init,
    f.fx.step = {};
    var It, $t, Vt = /^(?:toggle|show|hide)$/, Rt = /queueHooks$/;
    function Wt() {
        return t.setTimeout(function() {
            It = void 0
        }),
        It = f.now()
    }
    function zt(t, e) {
        var n, i = 0, r = {
            height: t
        };
        for (e = e ? 1 : 0; 4 > i; i += 2 - e)
            r["margin" + (n = V[i])] = r["padding" + n] = t;
        return e && (r.opacity = r.width = t),
        r
    }
    function Xt(t, e, n) {
        for (var i, r = (Ut.tweeners[e] || []).concat(Ut.tweeners["*"]), o = 0, a = r.length; a > o; o++)
            if (i = r[o].call(n, e, t))
                return i
    }
    function Ut(t, e, n) {
        var i, r, o = 0, a = Ut.prefilters.length, s = f.Deferred().always(function() {
            delete c.elem
        }), c = function() {
            if (r)
                return !1;
            for (var e = It || Wt(), n = Math.max(0, u.startTime + u.duration - e), i = 1 - (n / u.duration || 0), o = 0, a = u.tweens.length; a > o; o++)
                u.tweens[o].run(i);
            return s.notifyWith(t, [u, i, n]),
            1 > i && a ? n : (s.resolveWith(t, [u]),
            !1)
        }, u = s.promise({
            elem: t,
            props: f.extend({}, e),
            opts: f.extend(!0, {
                specialEasing: {},
                easing: f.easing._default
            }, n),
            originalProperties: e,
            originalOptions: n,
            startTime: It || Wt(),
            duration: n.duration,
            tweens: [],
            createTween: function(e, n) {
                var i = f.Tween(t, u.opts, e, n, u.opts.specialEasing[e] || u.opts.easing);
                return u.tweens.push(i),
                i
            },
            stop: function(e) {
                var n = 0
                  , i = e ? u.tweens.length : 0;
                if (r)
                    return this;
                for (r = !0; i > n; n++)
                    u.tweens[n].run(1);
                return e ? (s.notifyWith(t, [u, 1, 0]),
                s.resolveWith(t, [u, e])) : s.rejectWith(t, [u, e]),
                this
            }
        }), l = u.props;
        for (function(t, e) {
            var n, i, r, o, a;
            for (n in t)
                if (r = e[i = f.camelCase(n)],
                o = t[n],
                f.isArray(o) && (r = o[1],
                o = t[n] = o[0]),
                n !== i && (t[i] = o,
                delete t[n]),
                (a = f.cssHooks[i]) && "expand"in a)
                    for (n in o = a.expand(o),
                    delete t[i],
                    o)
                        n in t || (t[n] = o[n],
                        e[n] = r);
                else
                    e[i] = r
        }(l, u.opts.specialEasing); a > o; o++)
            if (i = Ut.prefilters[o].call(u, t, l, u.opts))
                return f.isFunction(i.stop) && (f._queueHooks(u.elem, u.opts.queue).stop = f.proxy(i.stop, i)),
                i;
        return f.map(l, Xt, u),
        f.isFunction(u.opts.start) && u.opts.start.call(t, u),
        f.fx.timer(f.extend(c, {
            elem: t,
            anim: u,
            queue: u.opts.queue
        })),
        u.progress(u.opts.progress).done(u.opts.done, u.opts.complete).fail(u.opts.fail).always(u.opts.always)
    }
    f.Animation = f.extend(Ut, {
        tweeners: {
            "*": [function(t, e) {
                var n = this.createTween(t, e);
                return W(n.elem, t, $.exec(e), n),
                n
            }
            ]
        },
        tweener: function(t, e) {
            f.isFunction(t) ? (e = t,
            t = ["*"]) : t = t.match(A);
            for (var n, i = 0, r = t.length; r > i; i++)
                n = t[i],
                Ut.tweeners[n] = Ut.tweeners[n] || [],
                Ut.tweeners[n].unshift(e)
        },
        prefilters: [function(t, e, n) {
            var i, r, o, a, s, c, u, l = this, d = {}, p = t.style, h = t.nodeType && R(t), g = N.get(t, "fxshow");
            for (i in n.queue || (null == (s = f._queueHooks(t, "fx")).unqueued && (s.unqueued = 0,
            c = s.empty.fire,
            s.empty.fire = function() {
                s.unqueued || c()
            }
            ),
            s.unqueued++,
            l.always(function() {
                l.always(function() {
                    s.unqueued--,
                    f.queue(t, "fx").length || s.empty.fire()
                })
            })),
            1 === t.nodeType && ("height"in e || "width"in e) && (n.overflow = [p.overflow, p.overflowX, p.overflowY],
            "inline" === ("none" === (u = f.css(t, "display")) ? N.get(t, "olddisplay") || xt(t.nodeName) : u) && "none" === f.css(t, "float") && (p.display = "inline-block")),
            n.overflow && (p.overflow = "hidden",
            l.always(function() {
                p.overflow = n.overflow[0],
                p.overflowX = n.overflow[1],
                p.overflowY = n.overflow[2]
            })),
            e)
                if (r = e[i],
                Vt.exec(r)) {
                    if (delete e[i],
                    o = o || "toggle" === r,
                    r === (h ? "hide" : "show")) {
                        if ("show" !== r || !g || void 0 === g[i])
                            continue;
                        h = !0
                    }
                    d[i] = g && g[i] || f.style(t, i)
                } else
                    u = void 0;
            if (f.isEmptyObject(d))
                "inline" === ("none" === u ? xt(t.nodeName) : u) && (p.display = u);
            else
                for (i in g ? "hidden"in g && (h = g.hidden) : g = N.access(t, "fxshow", {}),
                o && (g.hidden = !h),
                h ? f(t).show() : l.done(function() {
                    f(t).hide()
                }),
                l.done(function() {
                    var e;
                    for (e in N.remove(t, "fxshow"),
                    d)
                        f.style(t, e, d[e])
                }),
                d)
                    a = Xt(h ? g[i] : 0, i, l),
                    i in g || (g[i] = a.start,
                    h && (a.end = a.start,
                    a.start = "width" === i || "height" === i ? 1 : 0))
        }
        ],
        prefilter: function(t, e) {
            e ? Ut.prefilters.unshift(t) : Ut.prefilters.push(t)
        }
    }),
    f.speed = function(t, e, n) {
        var i = t && "object" == typeof t ? f.extend({}, t) : {
            complete: n || !n && e || f.isFunction(t) && t,
            duration: t,
            easing: n && e || e && !f.isFunction(e) && e
        };
        return i.duration = f.fx.off ? 0 : "number" == typeof i.duration ? i.duration : i.duration in f.fx.speeds ? f.fx.speeds[i.duration] : f.fx.speeds._default,
        null != i.queue && !0 !== i.queue || (i.queue = "fx"),
        i.old = i.complete,
        i.complete = function() {
            f.isFunction(i.old) && i.old.call(this),
            i.queue && f.dequeue(this, i.queue)
        }
        ,
        i
    }
    ,
    f.fn.extend({
        fadeTo: function(t, e, n, i) {
            return this.filter(R).css("opacity", 0).show().end().animate({
                opacity: e
            }, t, n, i)
        },
        animate: function(t, e, n, i) {
            var r = f.isEmptyObject(t)
              , o = f.speed(e, n, i)
              , a = function() {
                var e = Ut(this, f.extend({}, t), o);
                (r || N.get(this, "finish")) && e.stop(!0)
            };
            return a.finish = a,
            r || !1 === o.queue ? this.each(a) : this.queue(o.queue, a)
        },
        stop: function(t, e, n) {
            var i = function(t) {
                var e = t.stop;
                delete t.stop,
                e(n)
            };
            return "string" != typeof t && (n = e,
            e = t,
            t = void 0),
            e && !1 !== t && this.queue(t || "fx", []),
            this.each(function() {
                var e = !0
                  , r = null != t && t + "queueHooks"
                  , o = f.timers
                  , a = N.get(this);
                if (r)
                    a[r] && a[r].stop && i(a[r]);
                else
                    for (r in a)
                        a[r] && a[r].stop && Rt.test(r) && i(a[r]);
                for (r = o.length; r--; )
                    o[r].elem !== this || null != t && o[r].queue !== t || (o[r].anim.stop(n),
                    e = !1,
                    o.splice(r, 1));
                !e && n || f.dequeue(this, t)
            })
        },
        finish: function(t) {
            return !1 !== t && (t = t || "fx"),
            this.each(function() {
                var e, n = N.get(this), i = n[t + "queue"], r = n[t + "queueHooks"], o = f.timers, a = i ? i.length : 0;
                for (n.finish = !0,
                f.queue(this, t, []),
                r && r.stop && r.stop.call(this, !0),
                e = o.length; e--; )
                    o[e].elem === this && o[e].queue === t && (o[e].anim.stop(!0),
                    o.splice(e, 1));
                for (e = 0; a > e; e++)
                    i[e] && i[e].finish && i[e].finish.call(this);
                delete n.finish
            })
        }
    }),
    f.each(["toggle", "show", "hide"], function(t, e) {
        var n = f.fn[e];
        f.fn[e] = function(t, i, r) {
            return null == t || "boolean" == typeof t ? n.apply(this, arguments) : this.animate(zt(e, !0), t, i, r)
        }
    }),
    f.each({
        slideDown: zt("show"),
        slideUp: zt("hide"),
        slideToggle: zt("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(t, e) {
        f.fn[t] = function(t, n, i) {
            return this.animate(e, t, n, i)
        }
    }),
    f.timers = [],
    f.fx.tick = function() {
        var t, e = 0, n = f.timers;
        for (It = f.now(); e < n.length; e++)
            (t = n[e])() || n[e] !== t || n.splice(e--, 1);
        n.length || f.fx.stop(),
        It = void 0
    }
    ,
    f.fx.timer = function(t) {
        f.timers.push(t),
        t() ? f.fx.start() : f.timers.pop()
    }
    ,
    f.fx.interval = 13,
    f.fx.start = function() {
        $t || ($t = t.setInterval(f.fx.tick, f.fx.interval))
    }
    ,
    f.fx.stop = function() {
        t.clearInterval($t),
        $t = null
    }
    ,
    f.fx.speeds = {
        slow: 600,
        fast: 200,
        _default: 400
    },
    f.fn.delay = function(e, n) {
        return e = f.fx && f.fx.speeds[e] || e,
        n = n || "fx",
        this.queue(n, function(n, i) {
            var r = t.setTimeout(n, e);
            i.stop = function() {
                t.clearTimeout(r)
            }
        })
    }
    ,
    function() {
        var t = i.createElement("input")
          , e = i.createElement("select")
          , n = e.appendChild(i.createElement("option"));
        t.type = "checkbox",
        d.checkOn = "" !== t.value,
        d.optSelected = n.selected,
        e.disabled = !0,
        d.optDisabled = !n.disabled,
        (t = i.createElement("input")).value = "t",
        t.type = "radio",
        d.radioValue = "t" === t.value
    }();
    var Yt, Jt = f.expr.attrHandle;
    f.fn.extend({
        attr: function(t, e) {
            return L(this, f.attr, t, e, arguments.length > 1)
        },
        removeAttr: function(t) {
            return this.each(function() {
                f.removeAttr(this, t)
            })
        }
    }),
    f.extend({
        attr: function(t, e, n) {
            var i, r, o = t.nodeType;
            if (3 !== o && 8 !== o && 2 !== o)
                return void 0 === t.getAttribute ? f.prop(t, e, n) : (1 === o && f.isXMLDoc(t) || (e = e.toLowerCase(),
                r = f.attrHooks[e] || (f.expr.match.bool.test(e) ? Yt : void 0)),
                void 0 !== n ? null === n ? void f.removeAttr(t, e) : r && "set"in r && void 0 !== (i = r.set(t, n, e)) ? i : (t.setAttribute(e, n + ""),
                n) : r && "get"in r && null !== (i = r.get(t, e)) ? i : null == (i = f.find.attr(t, e)) ? void 0 : i)
        },
        attrHooks: {
            type: {
                set: function(t, e) {
                    if (!d.radioValue && "radio" === e && f.nodeName(t, "input")) {
                        var n = t.value;
                        return t.setAttribute("type", e),
                        n && (t.value = n),
                        e
                    }
                }
            }
        },
        removeAttr: function(t, e) {
            var n, i, r = 0, o = e && e.match(A);
            if (o && 1 === t.nodeType)
                for (; n = o[r++]; )
                    i = f.propFix[n] || n,
                    f.expr.match.bool.test(n) && (t[i] = !1),
                    t.removeAttribute(n)
        }
    }),
    Yt = {
        set: function(t, e, n) {
            return !1 === e ? f.removeAttr(t, n) : t.setAttribute(n, n),
            n
        }
    },
    f.each(f.expr.match.bool.source.match(/\w+/g), function(t, e) {
        var n = Jt[e] || f.find.attr;
        Jt[e] = function(t, e, i) {
            var r, o;
            return i || (o = Jt[e],
            Jt[e] = r,
            r = null != n(t, e, i) ? e.toLowerCase() : null,
            Jt[e] = o),
            r
        }
    });
    var Kt = /^(?:input|select|textarea|button)$/i
      , Zt = /^(?:a|area)$/i;
    f.fn.extend({
        prop: function(t, e) {
            return L(this, f.prop, t, e, arguments.length > 1)
        },
        removeProp: function(t) {
            return this.each(function() {
                delete this[f.propFix[t] || t]
            })
        }
    }),
    f.extend({
        prop: function(t, e, n) {
            var i, r, o = t.nodeType;
            if (3 !== o && 8 !== o && 2 !== o)
                return 1 === o && f.isXMLDoc(t) || (e = f.propFix[e] || e,
                r = f.propHooks[e]),
                void 0 !== n ? r && "set"in r && void 0 !== (i = r.set(t, n, e)) ? i : t[e] = n : r && "get"in r && null !== (i = r.get(t, e)) ? i : t[e]
        },
        propHooks: {
            tabIndex: {
                get: function(t) {
                    var e = f.find.attr(t, "tabindex");
                    return e ? parseInt(e, 10) : Kt.test(t.nodeName) || Zt.test(t.nodeName) && t.href ? 0 : -1
                }
            }
        },
        propFix: {
            for: "htmlFor",
            class: "className"
        }
    }),
    d.optSelected || (f.propHooks.selected = {
        get: function(t) {
            var e = t.parentNode;
            return e && e.parentNode && e.parentNode.selectedIndex,
            null
        },
        set: function(t) {
            var e = t.parentNode;
            e && (e.selectedIndex,
            e.parentNode && e.parentNode.selectedIndex)
        }
    }),
    f.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
        f.propFix[this.toLowerCase()] = this
    });
    var te = /[\t\r\n\f]/g;
    function ee(t) {
        return t.getAttribute && t.getAttribute("class") || ""
    }
    f.fn.extend({
        addClass: function(t) {
            var e, n, i, r, o, a, s, c = 0;
            if (f.isFunction(t))
                return this.each(function(e) {
                    f(this).addClass(t.call(this, e, ee(this)))
                });
            if ("string" == typeof t && t)
                for (e = t.match(A) || []; n = this[c++]; )
                    if (r = ee(n),
                    i = 1 === n.nodeType && (" " + r + " ").replace(te, " ")) {
                        for (a = 0; o = e[a++]; )
                            i.indexOf(" " + o + " ") < 0 && (i += o + " ");
                        r !== (s = f.trim(i)) && n.setAttribute("class", s)
                    }
            return this
        },
        removeClass: function(t) {
            var e, n, i, r, o, a, s, c = 0;
            if (f.isFunction(t))
                return this.each(function(e) {
                    f(this).removeClass(t.call(this, e, ee(this)))
                });
            if (!arguments.length)
                return this.attr("class", "");
            if ("string" == typeof t && t)
                for (e = t.match(A) || []; n = this[c++]; )
                    if (r = ee(n),
                    i = 1 === n.nodeType && (" " + r + " ").replace(te, " ")) {
                        for (a = 0; o = e[a++]; )
                            for (; i.indexOf(" " + o + " ") > -1; )
                                i = i.replace(" " + o + " ", " ");
                        r !== (s = f.trim(i)) && n.setAttribute("class", s)
                    }
            return this
        },
        toggleClass: function(t, e) {
            var n = typeof t;
            return "boolean" == typeof e && "string" === n ? e ? this.addClass(t) : this.removeClass(t) : f.isFunction(t) ? this.each(function(n) {
                f(this).toggleClass(t.call(this, n, ee(this), e), e)
            }) : this.each(function() {
                var e, i, r, o;
                if ("string" === n)
                    for (i = 0,
                    r = f(this),
                    o = t.match(A) || []; e = o[i++]; )
                        r.hasClass(e) ? r.removeClass(e) : r.addClass(e);
                else
                    void 0 !== t && "boolean" !== n || ((e = ee(this)) && N.set(this, "__className__", e),
                    this.setAttribute && this.setAttribute("class", e || !1 === t ? "" : N.get(this, "__className__") || ""))
            })
        },
        hasClass: function(t) {
            var e, n, i = 0;
            for (e = " " + t + " "; n = this[i++]; )
                if (1 === n.nodeType && (" " + ee(n) + " ").replace(te, " ").indexOf(e) > -1)
                    return !0;
            return !1
        }
    });
    var ne = /\r/g
      , ie = /[\x20\t\r\n\f]+/g;
    f.fn.extend({
        val: function(t) {
            var e, n, i, r = this[0];
            return arguments.length ? (i = f.isFunction(t),
            this.each(function(n) {
                var r;
                1 === this.nodeType && (null == (r = i ? t.call(this, n, f(this).val()) : t) ? r = "" : "number" == typeof r ? r += "" : f.isArray(r) && (r = f.map(r, function(t) {
                    return null == t ? "" : t + ""
                })),
                (e = f.valHooks[this.type] || f.valHooks[this.nodeName.toLowerCase()]) && "set"in e && void 0 !== e.set(this, r, "value") || (this.value = r))
            })) : r ? (e = f.valHooks[r.type] || f.valHooks[r.nodeName.toLowerCase()]) && "get"in e && void 0 !== (n = e.get(r, "value")) ? n : "string" == typeof (n = r.value) ? n.replace(ne, "") : null == n ? "" : n : void 0
        }
    }),
    f.extend({
        valHooks: {
            option: {
                get: function(t) {
                    var e = f.find.attr(t, "value");
                    return null != e ? e : f.trim(f.text(t)).replace(ie, " ")
                }
            },
            select: {
                get: function(t) {
                    for (var e, n, i = t.options, r = t.selectedIndex, o = "select-one" === t.type || 0 > r, a = o ? null : [], s = o ? r + 1 : i.length, c = 0 > r ? s : o ? r : 0; s > c; c++)
                        if (((n = i[c]).selected || c === r) && (d.optDisabled ? !n.disabled : null === n.getAttribute("disabled")) && (!n.parentNode.disabled || !f.nodeName(n.parentNode, "optgroup"))) {
                            if (e = f(n).val(),
                            o)
                                return e;
                            a.push(e)
                        }
                    return a
                },
                set: function(t, e) {
                    for (var n, i, r = t.options, o = f.makeArray(e), a = r.length; a--; )
                        ((i = r[a]).selected = f.inArray(f.valHooks.option.get(i), o) > -1) && (n = !0);
                    return n || (t.selectedIndex = -1),
                    o
                }
            }
        }
    }),
    f.each(["radio", "checkbox"], function() {
        f.valHooks[this] = {
            set: function(t, e) {
                return f.isArray(e) ? t.checked = f.inArray(f(t).val(), e) > -1 : void 0
            }
        },
        d.checkOn || (f.valHooks[this].get = function(t) {
            return null === t.getAttribute("value") ? "on" : t.value
        }
        )
    });
    var re = /^(?:focusinfocus|focusoutblur)$/;
    f.extend(f.event, {
        trigger: function(e, n, r, o) {
            var a, s, c, u, d, p, h, g = [r || i], m = l.call(e, "type") ? e.type : e, v = l.call(e, "namespace") ? e.namespace.split(".") : [];
            if (s = c = r = r || i,
            3 !== r.nodeType && 8 !== r.nodeType && !re.test(m + f.event.triggered) && (m.indexOf(".") > -1 && (v = m.split("."),
            m = v.shift(),
            v.sort()),
            d = m.indexOf(":") < 0 && "on" + m,
            (e = e[f.expando] ? e : new f.Event(m,"object" == typeof e && e)).isTrigger = o ? 2 : 3,
            e.namespace = v.join("."),
            e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + v.join("\\.(?:.*\\.|)") + "(\\.|$)") : null,
            e.result = void 0,
            e.target || (e.target = r),
            n = null == n ? [e] : f.makeArray(n, [e]),
            h = f.event.special[m] || {},
            o || !h.trigger || !1 !== h.trigger.apply(r, n))) {
                if (!o && !h.noBubble && !f.isWindow(r)) {
                    for (u = h.delegateType || m,
                    re.test(u + m) || (s = s.parentNode); s; s = s.parentNode)
                        g.push(s),
                        c = s;
                    c === (r.ownerDocument || i) && g.push(c.defaultView || c.parentWindow || t)
                }
                for (a = 0; (s = g[a++]) && !e.isPropagationStopped(); )
                    e.type = a > 1 ? u : h.bindType || m,
                    (p = (N.get(s, "events") || {})[e.type] && N.get(s, "handle")) && p.apply(s, n),
                    (p = d && s[d]) && p.apply && Q(s) && (e.result = p.apply(s, n),
                    !1 === e.result && e.preventDefault());
                return e.type = m,
                o || e.isDefaultPrevented() || h._default && !1 !== h._default.apply(g.pop(), n) || !Q(r) || d && f.isFunction(r[m]) && !f.isWindow(r) && ((c = r[d]) && (r[d] = null),
                f.event.triggered = m,
                r[m](),
                f.event.triggered = void 0,
                c && (r[d] = c)),
                e.result
            }
        },
        simulate: function(t, e, n) {
            var i = f.extend(new f.Event, n, {
                type: t,
                isSimulated: !0
            });
            f.event.trigger(i, null, e),
            i.isDefaultPrevented() && n.preventDefault()
        }
    }),
    f.fn.extend({
        trigger: function(t, e) {
            return this.each(function() {
                f.event.trigger(t, e, this)
            })
        },
        triggerHandler: function(t, e) {
            var n = this[0];
            return n ? f.event.trigger(t, e, n, !0) : void 0
        }
    }),
    f.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function(t, e) {
        f.fn[e] = function(t, n) {
            return arguments.length > 0 ? this.on(e, null, t, n) : this.trigger(e)
        }
    }),
    f.fn.extend({
        hover: function(t, e) {
            return this.mouseenter(t).mouseleave(e || t)
        }
    }),
    d.focusin = "onfocusin"in t,
    d.focusin || f.each({
        focus: "focusin",
        blur: "focusout"
    }, function(t, e) {
        var n = function(t) {
            f.event.simulate(e, t.target, f.event.fix(t))
        };
        f.event.special[e] = {
            setup: function() {
                var i = this.ownerDocument || this
                  , r = N.access(i, e);
                r || i.addEventListener(t, n, !0),
                N.access(i, e, (r || 0) + 1)
            },
            teardown: function() {
                var i = this.ownerDocument || this
                  , r = N.access(i, e) - 1;
                r ? N.access(i, e, r) : (i.removeEventListener(t, n, !0),
                N.remove(i, e))
            }
        }
    });
    var oe = t.location
      , ae = f.now()
      , se = /\?/;
    f.parseJSON = function(t) {
        return JSON.parse(t + "")
    }
    ,
    f.parseXML = function(e) {
        var n;
        if (!e || "string" != typeof e)
            return null;
        try {
            n = (new t.DOMParser).parseFromString(e, "text/xml")
        } catch (t) {
            n = void 0
        }
        return n && !n.getElementsByTagName("parsererror").length || f.error("Invalid XML: " + e),
        n
    }
    ;
    var ce = /#.*$/
      , ue = /([?&])_=[^&]*/
      , le = /^(.*?):[ \t]*([^\r\n]*)$/gm
      , de = /^(?:GET|HEAD)$/
      , pe = /^\/\//
      , fe = {}
      , he = {}
      , ge = "*/".concat("*")
      , me = i.createElement("a");
    function ve(t) {
        return function(e, n) {
            "string" != typeof e && (n = e,
            e = "*");
            var i, r = 0, o = e.toLowerCase().match(A) || [];
            if (f.isFunction(n))
                for (; i = o[r++]; )
                    "+" === i[0] ? (i = i.slice(1) || "*",
                    (t[i] = t[i] || []).unshift(n)) : (t[i] = t[i] || []).push(n)
        }
    }
    function ye(t, e, n, i) {
        var r = {}
          , o = t === he;
        function a(s) {
            var c;
            return r[s] = !0,
            f.each(t[s] || [], function(t, s) {
                var u = s(e, n, i);
                return "string" != typeof u || o || r[u] ? o ? !(c = u) : void 0 : (e.dataTypes.unshift(u),
                a(u),
                !1)
            }),
            c
        }
        return a(e.dataTypes[0]) || !r["*"] && a("*")
    }
    function be(t, e) {
        var n, i, r = f.ajaxSettings.flatOptions || {};
        for (n in e)
            void 0 !== e[n] && ((r[n] ? t : i || (i = {}))[n] = e[n]);
        return i && f.extend(!0, t, i),
        t
    }
    me.href = oe.href,
    f.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: oe.href,
            type: "GET",
            isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(oe.protocol),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
                "*": ge,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            converters: {
                "* text": String,
                "text html": !0,
                "text json": f.parseJSON,
                "text xml": f.parseXML
            },
            flatOptions: {
                url: !0,
                context: !0
            }
        },
        ajaxSetup: function(t, e) {
            return e ? be(be(t, f.ajaxSettings), e) : be(f.ajaxSettings, t)
        },
        ajaxPrefilter: ve(fe),
        ajaxTransport: ve(he),
        ajax: function(e, n) {
            "object" == typeof e && (n = e,
            e = void 0),
            n = n || {};
            var r, o, a, s, c, u, l, d, p = f.ajaxSetup({}, n), h = p.context || p, g = p.context && (h.nodeType || h.jquery) ? f(h) : f.event, m = f.Deferred(), v = f.Callbacks("once memory"), y = p.statusCode || {}, b = {}, P = {}, w = 0, k = "canceled", x = {
                readyState: 0,
                getResponseHeader: function(t) {
                    var e;
                    if (2 === w) {
                        if (!s)
                            for (s = {}; e = le.exec(a); )
                                s[e[1].toLowerCase()] = e[2];
                        e = s[t.toLowerCase()]
                    }
                    return null == e ? null : e
                },
                getAllResponseHeaders: function() {
                    return 2 === w ? a : null
                },
                setRequestHeader: function(t, e) {
                    var n = t.toLowerCase();
                    return w || (t = P[n] = P[n] || t,
                    b[t] = e),
                    this
                },
                overrideMimeType: function(t) {
                    return w || (p.mimeType = t),
                    this
                },
                statusCode: function(t) {
                    var e;
                    if (t)
                        if (2 > w)
                            for (e in t)
                                y[e] = [y[e], t[e]];
                        else
                            x.always(t[x.status]);
                    return this
                },
                abort: function(t) {
                    var e = t || k;
                    return r && r.abort(e),
                    C(0, e),
                    this
                }
            };
            if (m.promise(x).complete = v.add,
            x.success = x.done,
            x.error = x.fail,
            p.url = ((e || p.url || oe.href) + "").replace(ce, "").replace(pe, oe.protocol + "//"),
            p.type = n.method || n.type || p.method || p.type,
            p.dataTypes = f.trim(p.dataType || "*").toLowerCase().match(A) || [""],
            null == p.crossDomain) {
                u = i.createElement("a");
                try {
                    u.href = p.url,
                    u.href = u.href,
                    p.crossDomain = me.protocol + "//" + me.host != u.protocol + "//" + u.host
                } catch (t) {
                    p.crossDomain = !0
                }
            }
            if (p.data && p.processData && "string" != typeof p.data && (p.data = f.param(p.data, p.traditional)),
            ye(fe, p, n, x),
            2 === w)
                return x;
            for (d in (l = f.event && p.global) && 0 == f.active++ && f.event.trigger("ajaxStart"),
            p.type = p.type.toUpperCase(),
            p.hasContent = !de.test(p.type),
            o = p.url,
            p.hasContent || (p.data && (o = p.url += (se.test(o) ? "&" : "?") + p.data,
            delete p.data),
            !1 === p.cache && (p.url = ue.test(o) ? o.replace(ue, "$1_=" + ae++) : o + (se.test(o) ? "&" : "?") + "_=" + ae++)),
            p.ifModified && (f.lastModified[o] && x.setRequestHeader("If-Modified-Since", f.lastModified[o]),
            f.etag[o] && x.setRequestHeader("If-None-Match", f.etag[o])),
            (p.data && p.hasContent && !1 !== p.contentType || n.contentType) && x.setRequestHeader("Content-Type", p.contentType),
            x.setRequestHeader("Accept", p.dataTypes[0] && p.accepts[p.dataTypes[0]] ? p.accepts[p.dataTypes[0]] + ("*" !== p.dataTypes[0] ? ", " + ge + "; q=0.01" : "") : p.accepts["*"]),
            p.headers)
                x.setRequestHeader(d, p.headers[d]);
            if (p.beforeSend && (!1 === p.beforeSend.call(h, x, p) || 2 === w))
                return x.abort();
            for (d in k = "abort",
            {
                success: 1,
                error: 1,
                complete: 1
            })
                x[d](p[d]);
            if (r = ye(he, p, n, x)) {
                if (x.readyState = 1,
                l && g.trigger("ajaxSend", [x, p]),
                2 === w)
                    return x;
                p.async && p.timeout > 0 && (c = t.setTimeout(function() {
                    x.abort("timeout")
                }, p.timeout));
                try {
                    w = 1,
                    r.send(b, C)
                } catch (t) {
                    if (!(2 > w))
                        throw t;
                    C(-1, t)
                }
            } else
                C(-1, "No Transport");
            function C(e, n, i, s) {
                var u, d, b, P, k, C = n;
                2 !== w && (w = 2,
                c && t.clearTimeout(c),
                r = void 0,
                a = s || "",
                x.readyState = e > 0 ? 4 : 0,
                u = e >= 200 && 300 > e || 304 === e,
                i && (P = function(t, e, n) {
                    for (var i, r, o, a, s = t.contents, c = t.dataTypes; "*" === c[0]; )
                        c.shift(),
                        void 0 === i && (i = t.mimeType || e.getResponseHeader("Content-Type"));
                    if (i)
                        for (r in s)
                            if (s[r] && s[r].test(i)) {
                                c.unshift(r);
                                break
                            }
                    if (c[0]in n)
                        o = c[0];
                    else {
                        for (r in n) {
                            if (!c[0] || t.converters[r + " " + c[0]]) {
                                o = r;
                                break
                            }
                            a || (a = r)
                        }
                        o = o || a
                    }
                    return o ? (o !== c[0] && c.unshift(o),
                    n[o]) : void 0
                }(p, x, i)),
                P = function(t, e, n, i) {
                    var r, o, a, s, c, u = {}, l = t.dataTypes.slice();
                    if (l[1])
                        for (a in t.converters)
                            u[a.toLowerCase()] = t.converters[a];
                    for (o = l.shift(); o; )
                        if (t.responseFields[o] && (n[t.responseFields[o]] = e),
                        !c && i && t.dataFilter && (e = t.dataFilter(e, t.dataType)),
                        c = o,
                        o = l.shift())
                            if ("*" === o)
                                o = c;
                            else if ("*" !== c && c !== o) {
                                if (!(a = u[c + " " + o] || u["* " + o]))
                                    for (r in u)
                                        if ((s = r.split(" "))[1] === o && (a = u[c + " " + s[0]] || u["* " + s[0]])) {
                                            !0 === a ? a = u[r] : !0 !== u[r] && (o = s[0],
                                            l.unshift(s[1]));
                                            break
                                        }
                                if (!0 !== a)
                                    if (a && t.throws)
                                        e = a(e);
                                    else
                                        try {
                                            e = a(e)
                                        } catch (t) {
                                            return {
                                                state: "parsererror",
                                                error: a ? t : "No conversion from " + c + " to " + o
                                            }
                                        }
                            }
                    return {
                        state: "success",
                        data: e
                    }
                }(p, P, x, u),
                u ? (p.ifModified && ((k = x.getResponseHeader("Last-Modified")) && (f.lastModified[o] = k),
                (k = x.getResponseHeader("etag")) && (f.etag[o] = k)),
                204 === e || "HEAD" === p.type ? C = "nocontent" : 304 === e ? C = "notmodified" : (C = P.state,
                d = P.data,
                u = !(b = P.error))) : (b = C,
                !e && C || (C = "error",
                0 > e && (e = 0))),
                x.status = e,
                x.statusText = (n || C) + "",
                u ? m.resolveWith(h, [d, C, x]) : m.rejectWith(h, [x, C, b]),
                x.statusCode(y),
                y = void 0,
                l && g.trigger(u ? "ajaxSuccess" : "ajaxError", [x, p, u ? d : b]),
                v.fireWith(h, [x, C]),
                l && (g.trigger("ajaxComplete", [x, p]),
                --f.active || f.event.trigger("ajaxStop")))
            }
            return x
        },
        getJSON: function(t, e, n) {
            return f.get(t, e, n, "json")
        },
        getScript: function(t, e) {
            return f.get(t, void 0, e, "script")
        }
    }),
    f.each(["get", "post"], function(t, e) {
        f[e] = function(t, n, i, r) {
            return f.isFunction(n) && (r = r || i,
            i = n,
            n = void 0),
            f.ajax(f.extend({
                url: t,
                type: e,
                dataType: r,
                data: n,
                success: i
            }, f.isPlainObject(t) && t))
        }
    }),
    f._evalUrl = function(t) {
        return f.ajax({
            url: t,
            type: "GET",
            dataType: "script",
            async: !1,
            global: !1,
            throws: !0
        })
    }
    ,
    f.fn.extend({
        wrapAll: function(t) {
            var e;
            return f.isFunction(t) ? this.each(function(e) {
                f(this).wrapAll(t.call(this, e))
            }) : (this[0] && (e = f(t, this[0].ownerDocument).eq(0).clone(!0),
            this[0].parentNode && e.insertBefore(this[0]),
            e.map(function() {
                for (var t = this; t.firstElementChild; )
                    t = t.firstElementChild;
                return t
            }).append(this)),
            this)
        },
        wrapInner: function(t) {
            return f.isFunction(t) ? this.each(function(e) {
                f(this).wrapInner(t.call(this, e))
            }) : this.each(function() {
                var e = f(this)
                  , n = e.contents();
                n.length ? n.wrapAll(t) : e.append(t)
            })
        },
        wrap: function(t) {
            var e = f.isFunction(t);
            return this.each(function(n) {
                f(this).wrapAll(e ? t.call(this, n) : t)
            })
        },
        unwrap: function() {
            return this.parent().each(function() {
                f.nodeName(this, "body") || f(this).replaceWith(this.childNodes)
            }).end()
        }
    }),
    f.expr.filters.hidden = function(t) {
        return !f.expr.filters.visible(t)
    }
    ,
    f.expr.filters.visible = function(t) {
        return t.offsetWidth > 0 || t.offsetHeight > 0 || t.getClientRects().length > 0
    }
    ;
    var Pe = /%20/g
      , we = /\[\]$/
      , ke = /\r?\n/g
      , xe = /^(?:submit|button|image|reset|file)$/i
      , Ce = /^(?:input|select|textarea|keygen)/i;
    function Oe(t, e, n, i) {
        var r;
        if (f.isArray(e))
            f.each(e, function(e, r) {
                n || we.test(t) ? i(t, r) : Oe(t + "[" + ("object" == typeof r && null != r ? e : "") + "]", r, n, i)
            });
        else if (n || "object" !== f.type(e))
            i(t, e);
        else
            for (r in e)
                Oe(t + "[" + r + "]", e[r], n, i)
    }
    f.param = function(t, e) {
        var n, i = [], r = function(t, e) {
            e = f.isFunction(e) ? e() : null == e ? "" : e,
            i[i.length] = encodeURIComponent(t) + "=" + encodeURIComponent(e)
        };
        if (void 0 === e && (e = f.ajaxSettings && f.ajaxSettings.traditional),
        f.isArray(t) || t.jquery && !f.isPlainObject(t))
            f.each(t, function() {
                r(this.name, this.value)
            });
        else
            for (n in t)
                Oe(n, t[n], e, r);
        return i.join("&").replace(Pe, "+")
    }
    ,
    f.fn.extend({
        serialize: function() {
            return f.param(this.serializeArray())
        },
        serializeArray: function() {
            return this.map(function() {
                var t = f.prop(this, "elements");
                return t ? f.makeArray(t) : this
            }).filter(function() {
                var t = this.type;
                return this.name && !f(this).is(":disabled") && Ce.test(this.nodeName) && !xe.test(t) && (this.checked || !z.test(t))
            }).map(function(t, e) {
                var n = f(this).val();
                return null == n ? null : f.isArray(n) ? f.map(n, function(t) {
                    return {
                        name: e.name,
                        value: t.replace(ke, "\r\n")
                    }
                }) : {
                    name: e.name,
                    value: n.replace(ke, "\r\n")
                }
            }).get()
        }
    }),
    f.ajaxSettings.xhr = function() {
        try {
            return new t.XMLHttpRequest
        } catch (t) {}
    }
    ;
    var je = {
        0: 200,
        1223: 204
    }
      , Te = f.ajaxSettings.xhr();
    d.cors = !!Te && "withCredentials"in Te,
    d.ajax = Te = !!Te,
    f.ajaxTransport(function(e) {
        var n, i;
        return d.cors || Te && !e.crossDomain ? {
            send: function(r, o) {
                var a, s = e.xhr();
                if (s.open(e.type, e.url, e.async, e.username, e.password),
                e.xhrFields)
                    for (a in e.xhrFields)
                        s[a] = e.xhrFields[a];
                for (a in e.mimeType && s.overrideMimeType && s.overrideMimeType(e.mimeType),
                e.crossDomain || r["X-Requested-With"] || (r["X-Requested-With"] = "XMLHttpRequest"),
                r)
                    s.setRequestHeader(a, r[a]);
                n = function(t) {
                    return function() {
                        n && (n = i = s.onload = s.onerror = s.onabort = s.onreadystatechange = null,
                        "abort" === t ? s.abort() : "error" === t ? "number" != typeof s.status ? o(0, "error") : o(s.status, s.statusText) : o(je[s.status] || s.status, s.statusText, "text" !== (s.responseType || "text") || "string" != typeof s.responseText ? {
                            binary: s.response
                        } : {
                            text: s.responseText
                        }, s.getAllResponseHeaders()))
                    }
                }
                ,
                s.onload = n(),
                i = s.onerror = n("error"),
                void 0 !== s.onabort ? s.onabort = i : s.onreadystatechange = function() {
                    4 === s.readyState && t.setTimeout(function() {
                        n && i()
                    })
                }
                ,
                n = n("abort");
                try {
                    s.send(e.hasContent && e.data || null)
                } catch (t) {
                    if (n)
                        throw t
                }
            },
            abort: function() {
                n && n()
            }
        } : void 0
    }),
    f.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(t) {
                return f.globalEval(t),
                t
            }
        }
    }),
    f.ajaxPrefilter("script", function(t) {
        void 0 === t.cache && (t.cache = !1),
        t.crossDomain && (t.type = "GET")
    }),
    f.ajaxTransport("script", function(t) {
        var e, n;
        if (t.crossDomain)
            return {
                send: function(r, o) {
                    e = f("<script>").prop({
                        charset: t.scriptCharset,
                        src: t.url
                    }).on("load error", n = function(t) {
                        e.remove(),
                        n = null,
                        t && o("error" === t.type ? 404 : 200, t.type)
                    }
                    ),
                    i.head.appendChild(e[0])
                },
                abort: function() {
                    n && n()
                }
            }
    });
    var _e = []
      , Ge = /(=)\?(?=&|$)|\?\?/;
    f.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var t = _e.pop() || f.expando + "_" + ae++;
            return this[t] = !0,
            t
        }
    }),
    f.ajaxPrefilter("json jsonp", function(e, n, i) {
        var r, o, a, s = !1 !== e.jsonp && (Ge.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && Ge.test(e.data) && "data");
        return s || "jsonp" === e.dataTypes[0] ? (r = e.jsonpCallback = f.isFunction(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback,
        s ? e[s] = e[s].replace(Ge, "$1" + r) : !1 !== e.jsonp && (e.url += (se.test(e.url) ? "&" : "?") + e.jsonp + "=" + r),
        e.converters["script json"] = function() {
            return a || f.error(r + " was not called"),
            a[0]
        }
        ,
        e.dataTypes[0] = "json",
        o = t[r],
        t[r] = function() {
            a = arguments
        }
        ,
        i.always(function() {
            void 0 === o ? f(t).removeProp(r) : t[r] = o,
            e[r] && (e.jsonpCallback = n.jsonpCallback,
            _e.push(r)),
            a && f.isFunction(o) && o(a[0]),
            a = o = void 0
        }),
        "script") : void 0
    }),
    f.parseHTML = function(t, e, n) {
        if (!t || "string" != typeof t)
            return null;
        "boolean" == typeof e && (n = e,
        e = !1),
        e = e || i;
        var r = x.exec(t)
          , o = !n && [];
        return r ? [e.createElement(r[1])] : (r = tt([t], e, o),
        o && o.length && f(o).remove(),
        f.merge([], r.childNodes))
    }
    ;
    var Se = f.fn.load;
    function Fe(t) {
        return f.isWindow(t) ? t : 9 === t.nodeType && t.defaultView
    }
    f.fn.load = function(t, e, n) {
        if ("string" != typeof t && Se)
            return Se.apply(this, arguments);
        var i, r, o, a = this, s = t.indexOf(" ");
        return s > -1 && (i = f.trim(t.slice(s)),
        t = t.slice(0, s)),
        f.isFunction(e) ? (n = e,
        e = void 0) : e && "object" == typeof e && (r = "POST"),
        a.length > 0 && f.ajax({
            url: t,
            type: r || "GET",
            dataType: "html",
            data: e
        }).done(function(t) {
            o = arguments,
            a.html(i ? f("<div>").append(f.parseHTML(t)).find(i) : t)
        }).always(n && function(t, e) {
            a.each(function() {
                n.apply(this, o || [t.responseText, e, t])
            })
        }
        ),
        this
    }
    ,
    f.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(t, e) {
        f.fn[e] = function(t) {
            return this.on(e, t)
        }
    }),
    f.expr.filters.animated = function(t) {
        return f.grep(f.timers, function(e) {
            return t === e.elem
        }).length
    }
    ,
    f.offset = {
        setOffset: function(t, e, n) {
            var i, r, o, a, s, c, u = f.css(t, "position"), l = f(t), d = {};
            "static" === u && (t.style.position = "relative"),
            s = l.offset(),
            o = f.css(t, "top"),
            c = f.css(t, "left"),
            ("absolute" === u || "fixed" === u) && (o + c).indexOf("auto") > -1 ? (a = (i = l.position()).top,
            r = i.left) : (a = parseFloat(o) || 0,
            r = parseFloat(c) || 0),
            f.isFunction(e) && (e = e.call(t, n, f.extend({}, s))),
            null != e.top && (d.top = e.top - s.top + a),
            null != e.left && (d.left = e.left - s.left + r),
            "using"in e ? e.using.call(t, d) : l.css(d)
        }
    },
    f.fn.extend({
        offset: function(t) {
            if (arguments.length)
                return void 0 === t ? this : this.each(function(e) {
                    f.offset.setOffset(this, t, e)
                });
            var e, n, i = this[0], r = {
                top: 0,
                left: 0
            }, o = i && i.ownerDocument;
            return o ? (e = o.documentElement,
            f.contains(e, i) ? (r = i.getBoundingClientRect(),
            n = Fe(o),
            {
                top: r.top + n.pageYOffset - e.clientTop,
                left: r.left + n.pageXOffset - e.clientLeft
            }) : r) : void 0
        },
        position: function() {
            if (this[0]) {
                var t, e, n = this[0], i = {
                    top: 0,
                    left: 0
                };
                return "fixed" === f.css(n, "position") ? e = n.getBoundingClientRect() : (t = this.offsetParent(),
                e = this.offset(),
                f.nodeName(t[0], "html") || (i = t.offset()),
                i.top += f.css(t[0], "borderTopWidth", !0),
                i.left += f.css(t[0], "borderLeftWidth", !0)),
                {
                    top: e.top - i.top - f.css(n, "marginTop", !0),
                    left: e.left - i.left - f.css(n, "marginLeft", !0)
                }
            }
        },
        offsetParent: function() {
            return this.map(function() {
                for (var t = this.offsetParent; t && "static" === f.css(t, "position"); )
                    t = t.offsetParent;
                return t || _t
            })
        }
    }),
    f.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(t, e) {
        var n = "pageYOffset" === e;
        f.fn[t] = function(i) {
            return L(this, function(t, i, r) {
                var o = Fe(t);
                return void 0 === r ? o ? o[e] : t[i] : void (o ? o.scrollTo(n ? o.pageXOffset : r, n ? r : o.pageYOffset) : t[i] = r)
            }, t, i, arguments.length)
        }
    }),
    f.each(["top", "left"], function(t, e) {
        f.cssHooks[e] = St(d.pixelPosition, function(t, n) {
            return n ? (n = Gt(t, e),
            Ot.test(n) ? f(t).position()[e] + "px" : n) : void 0
        })
    }),
    f.each({
        Height: "height",
        Width: "width"
    }, function(t, e) {
        f.each({
            padding: "inner" + t,
            content: e,
            "": "outer" + t
        }, function(n, i) {
            f.fn[i] = function(i, r) {
                var o = arguments.length && (n || "boolean" != typeof i)
                  , a = n || (!0 === i || !0 === r ? "margin" : "border");
                return L(this, function(e, n, i) {
                    var r;
                    return f.isWindow(e) ? e.document.documentElement["client" + t] : 9 === e.nodeType ? (r = e.documentElement,
                    Math.max(e.body["scroll" + t], r["scroll" + t], e.body["offset" + t], r["offset" + t], r["client" + t])) : void 0 === i ? f.css(e, n, a) : f.style(e, n, i, a)
                }, e, o ? i : void 0, o, null)
            }
        })
    }),
    f.fn.extend({
        bind: function(t, e, n) {
            return this.on(t, null, e, n)
        },
        unbind: function(t, e) {
            return this.off(t, null, e)
        },
        delegate: function(t, e, n, i) {
            return this.on(e, t, n, i)
        },
        undelegate: function(t, e, n) {
            return 1 === arguments.length ? this.off(t, "**") : this.off(e, t || "**", n)
        },
        size: function() {
            return this.length
        }
    }),
    f.fn.andSelf = f.fn.addBack,
    "function" == typeof define && define.amd && define("jquery", [], function() {
        return f
    });
    var Ae = t.jQuery
      , De = t.$;
    return f.noConflict = function(e) {
        return t.$ === f && (t.$ = De),
        e && t.jQuery === f && (t.jQuery = Ae),
        f
    }
    ,
    e || (t.jQuery = t.$ = f),
    f
});
var FlipClock, Base = function() {};
Base.extend = function(t, e) {
    "use strict";
    var n = Base.prototype.extend;
    Base._prototyping = !0;
    var i = new this;
    n.call(i, t),
    i.base = function() {}
    ,
    delete Base._prototyping;
    var r = i.constructor
      , o = i.constructor = function() {
        if (!Base._prototyping)
            if (this._constructing || this.constructor == o)
                this._constructing = !0,
                r.apply(this, arguments),
                delete this._constructing;
            else if (null !== arguments[0])
                return (arguments[0].extend || n).call(arguments[0], i)
    }
    ;
    return o.ancestor = this,
    o.extend = this.extend,
    o.forEach = this.forEach,
    o.implement = this.implement,
    o.prototype = i,
    o.toString = this.toString,
    o.valueOf = function(t) {
        return "object" == t ? o : r.valueOf()
    }
    ,
    n.call(o, e),
    "function" == typeof o.init && o.init(),
    o
}
,
Base.prototype = {
    extend: function(t, e) {
        if (arguments.length > 1) {
            var n = this[t];
            if (n && "function" == typeof e && (!n.valueOf || n.valueOf() != e.valueOf()) && /\bbase\b/.test(e)) {
                var i = e.valueOf();
                (e = function() {
                    var t = this.base || Base.prototype.base;
                    this.base = n;
                    var e = i.apply(this, arguments);
                    return this.base = t,
                    e
                }
                ).valueOf = function(t) {
                    return "object" == t ? e : i
                }
                ,
                e.toString = Base.toString
            }
            this[t] = e
        } else if (t) {
            var r = Base.prototype.extend;
            Base._prototyping || "function" == typeof this || (r = this.extend || r);
            for (var o = {
                toSource: null
            }, a = ["constructor", "toString", "valueOf"], s = Base._prototyping ? 0 : 1; c = a[s++]; )
                t[c] != o[c] && r.call(this, c, t[c]);
            for (var c in t)
                o[c] || r.call(this, c, t[c])
        }
        return this
    }
},
Base = Base.extend({
    constructor: function() {
        this.extend(arguments[0])
    }
}, {
    ancestor: Object,
    version: "1.1",
    forEach: function(t, e, n) {
        for (var i in t)
            void 0 === this.prototype[i] && e.call(n, t[i], i, t)
    },
    implement: function() {
        for (var t = 0; t < arguments.length; t++)
            "function" == typeof arguments[t] ? arguments[t](this.prototype) : this.prototype.extend(arguments[t]);
        return this
    },
    toString: function() {
        return String(this.valueOf())
    }
}),
function(t) {
    "use strict";
    (FlipClock = function(t, e, n) {
        return e instanceof Object && e instanceof Date == 0 && (n = e,
        e = 0),
        new FlipClock.Factory(t,e,n)
    }
    ).Lang = {},
    FlipClock.Base = Base.extend({
        buildDate: "2014-12-12",
        version: "0.7.7",
        constructor: function(e, n) {
            "object" != typeof e && (e = {}),
            "object" != typeof n && (n = {}),
            this.setOptions(t.extend(!0, {}, e, n))
        },
        callback: function(t) {
            if ("function" == typeof t) {
                for (var e = [], n = 1; n <= arguments.length; n++)
                    arguments[n] && e.push(arguments[n]);
                t.apply(this, e)
            }
        },
        log: function(t) {
            window.console && console.log && console.log(t)
        },
        getOption: function(t) {
            return !!this[t] && this[t]
        },
        getOptions: function() {
            return this
        },
        setOption: function(t, e) {
            this[t] = e
        },
        setOptions: function(t) {
            for (var e in t)
                void 0 !== t[e] && this.setOption(e, t[e])
        }
    })
}(jQuery),
function(t) {
    "use strict";
    FlipClock.Face = FlipClock.Base.extend({
        autoStart: !0,
        dividers: [],
        factory: !1,
        lists: [],
        constructor: function(t, e) {
            this.dividers = [],
            this.lists = [],
            this.base(e),
            this.factory = t
        },
        build: function() {
            this.autoStart && this.start()
        },
        createDivider: function(e, n, i) {
            "boolean" != typeof n && n || (i = n,
            n = e);
            var r = ['<span class="' + this.factory.classes.dot + ' top"></span>', '<span class="' + this.factory.classes.dot + ' bottom"></span>'].join("");
            i && (r = ""),
            e = this.factory.localize(e);
            var o = ['<span class="' + this.factory.classes.divider + " " + (n || "").toLowerCase() + '">', '<span class="' + this.factory.classes.label + '">' + (e || "") + "</span>", r, "</span>"]
              , a = t(o.join(""));
            return this.dividers.push(a),
            a
        },
        createList: function(t, e) {
            "object" == typeof t && (e = t,
            t = 0);
            var n = new FlipClock.List(this.factory,t,e);
            return this.lists.push(n),
            n
        },
        reset: function() {
            this.factory.time = new FlipClock.Time(this.factory,this.factory.original ? Math.round(this.factory.original) : 0,{
                minimumDigits: this.factory.minimumDigits
            }),
            this.flip(this.factory.original, !1)
        },
        appendDigitToClock: function(t) {
            t.$el.append(!1)
        },
        addDigit: function(t) {
            var e = this.createList(t, {
                classes: {
                    active: this.factory.classes.active,
                    before: this.factory.classes.before,
                    flip: this.factory.classes.flip
                }
            });
            this.appendDigitToClock(e)
        },
        start: function() {},
        stop: function() {},
        autoIncrement: function() {
            this.factory.countdown ? this.decrement() : this.increment()
        },
        increment: function() {
            this.factory.time.addSecond()
        },
        decrement: function() {
            0 == this.factory.time.getTimeSeconds() ? this.factory.stop() : this.factory.time.subSecond()
        },
        flip: function(e, n) {
            var i = this;
            t.each(e, function(t, e) {
                var r = i.lists[t];
                r ? (n || e == r.digit || r.play(),
                r.select(e)) : i.addDigit(e)
            })
        }
    })
}(jQuery),
function(t) {
    "use strict";
    FlipClock.Factory = FlipClock.Base.extend({
        animationRate: 1e3,
        autoStart: !0,
        callbacks: {
            destroy: !1,
            create: !1,
            init: !1,
            interval: !1,
            start: !1,
            stop: !1,
            reset: !1
        },
        classes: {
            active: "flip-clock-active",
            before: "flip-clock-before",
            divider: "flip-clock-divider",
            dot: "flip-clock-dot",
            label: "flip-clock-label",
            flip: "flip",
            play: "play",
            wrapper: "flip-clock-wrapper"
        },
        clockFace: "HourlyCounter",
        countdown: !1,
        defaultClockFace: "HourlyCounter",
        defaultLanguage: "english",
        $el: !1,
        face: !0,
        lang: !1,
        language: "english",
        minimumDigits: 0,
        original: !1,
        running: !1,
        time: !1,
        timer: !1,
        $wrapper: !1,
        constructor: function(e, n, i) {
            i || (i = {}),
            this.lists = [],
            this.running = !1,
            this.base(i),
            this.$el = t(e).addClass(this.classes.wrapper),
            this.$wrapper = this.$el,
            this.original = n instanceof Date ? n : n ? Math.round(n) : 0,
            this.time = new FlipClock.Time(this,this.original,{
                minimumDigits: this.minimumDigits,
                animationRate: this.animationRate
            }),
            this.timer = new FlipClock.Timer(this,i),
            this.loadLanguage(this.language),
            this.loadClockFace(this.clockFace, i),
            this.autoStart && this.start()
        },
        loadClockFace: function(t, e) {
            var n, i = "Face", r = !1;
            return t = t.ucfirst() + i,
            this.face.stop && (this.stop(),
            r = !0),
            this.$el.html(""),
            this.time.minimumDigits = this.minimumDigits,
            (n = FlipClock[t] ? new FlipClock[t](this,e) : new FlipClock[this.defaultClockFace + i](this,e)).build(),
            this.face = n,
            r && this.start(),
            this.face
        },
        loadLanguage: function(t) {
            var e;
            return e = FlipClock.Lang[t.ucfirst()] ? FlipClock.Lang[t.ucfirst()] : FlipClock.Lang[t] ? FlipClock.Lang[t] : FlipClock.Lang[this.defaultLanguage],
            this.lang = e
        },
        localize: function(t, e) {
            var n = this.lang;
            if (!t)
                return null;
            var i = t.toLowerCase();
            return "object" == typeof e && (n = e),
            n && n[i] ? n[i] : t
        },
        start: function(t) {
            var e = this;
            e.running || e.countdown && !(e.countdown && e.time.time > 0) ? e.log("Trying to start timer when countdown already at 0") : (e.face.start(e.time),
            e.timer.start(function() {
                e.flip(),
                "function" == typeof t && t()
            }))
        },
        stop: function(t) {
            for (var e in this.face.stop(),
            this.timer.stop(t),
            this.lists)
                this.lists.hasOwnProperty(e) && this.lists[e].stop()
        },
        reset: function(t) {
            this.timer.reset(t),
            this.face.reset()
        },
        setTime: function(t) {
            this.time.time = t,
            this.flip(!0)
        },
        getTime: function(t) {
            return this.time
        },
        setCountdown: function(t) {
            var e = this.running;
            this.countdown = !!t,
            e && (this.stop(),
            this.start())
        },
        flip: function(t) {
            this.face.flip(!1, t)
        }
    })
}(jQuery),
function(t) {
    "use strict";
    FlipClock.List = FlipClock.Base.extend({
        digit: 0,
        classes: {
            active: "flip-clock-active",
            before: "flip-clock-before",
            flip: "flip"
        },
        factory: !1,
        $el: !1,
        $obj: !1,
        items: [],
        lastDigit: 0,
        constructor: function(t, e, n) {
            this.factory = t,
            this.digit = e,
            this.lastDigit = e,
            this.$el = this.createList(),
            this.$obj = this.$el,
            e > 0 && this.select(e),
            this.factory.$el.append(this.$el)
        },
        select: function(t) {
            if (void 0 === t ? t = this.digit : this.digit = t,
            this.digit != this.lastDigit) {
                var e = this.$el.find("." + this.classes.before).removeClass(this.classes.before);
                this.$el.find("." + this.classes.active).removeClass(this.classes.active).addClass(this.classes.before),
                this.appendListItem(this.classes.active, this.digit),
                e.remove(),
                this.lastDigit = this.digit
            }
        },
        play: function() {
            this.$el.addClass(this.factory.classes.play)
        },
        stop: function() {
            var t = this;
            setTimeout(function() {
                t.$el.removeClass(t.factory.classes.play)
            }, this.factory.timer.interval)
        },
        createListItem: function(t, e) {
            return ['<li class="' + (t || "") + '">', '<a href="#">', '<div class="up">', '<div class="shadow"></div>', '<div class="inn">' + (e || "") + "</div>", "</div>", '<div class="down">', '<div class="shadow"></div>', '<div class="inn">' + (e || "") + "</div>", "</div>", "</a>", "</li>"].join("")
        },
        appendListItem: function(t, e) {
            var n = this.createListItem(t, e);
            this.$el.append(n)
        },
        createList: function() {
            var e = this.getPrevDigit() ? this.getPrevDigit() : this.digit;
            return t(['<ul class="' + this.classes.flip + " " + (this.factory.running ? this.factory.classes.play : "") + '">', this.createListItem(this.classes.before, e), this.createListItem(this.classes.active, this.digit), "</ul>"].join(""))
        },
        getNextDigit: function() {
            return 9 == this.digit ? 0 : this.digit + 1
        },
        getPrevDigit: function() {
            return 0 == this.digit ? 9 : this.digit - 1
        }
    })
}(jQuery),
function(t) {
    "use strict";
    String.prototype.ucfirst = function() {
        return this.substr(0, 1).toUpperCase() + this.substr(1)
    }
    ,
    t.fn.FlipClock = function(e, n) {
        return new FlipClock(t(this),e,n)
    }
    ,
    t.fn.flipClock = function(e, n) {
        return t.fn.FlipClock(e, n)
    }
}(jQuery),
function(t) {
    "use strict";
    FlipClock.Time = FlipClock.Base.extend({
        time: 0,
        factory: !1,
        minimumDigits: 0,
        constructor: function(t, e, n) {
            "object" != typeof n && (n = {}),
            n.minimumDigits || (n.minimumDigits = t.minimumDigits),
            this.base(n),
            this.factory = t,
            e && (this.time = e)
        },
        convertDigitsToArray: function(t) {
            var e = [];
            t = t.toString();
            for (var n = 0; n < t.length; n++)
                t[n].match(/^\d*$/g) && e.push(t[n]);
            return e
        },
        digit: function(t) {
            var e = this.toString()
              , n = e.length;
            return !!e[n - t] && e[n - t]
        },
        digitize: function(e) {
            var n = [];
            if (t.each(e, function(t, e) {
                1 == (e = e.toString()).length && (e = "0" + e);
                for (var i = 0; i < e.length; i++)
                    n.push(e.charAt(i))
            }),
            n.length > this.minimumDigits && (this.minimumDigits = n.length),
            this.minimumDigits > n.length)
                for (var i = n.length; i < this.minimumDigits; i++)
                    n.unshift("0");
            return n
        },
        getDateObject: function() {
            return this.time instanceof Date ? this.time : new Date((new Date).getTime() + 1e3 * this.getTimeSeconds())
        },
        getDayCounter: function(t) {
            var e = [this.getDays(), this.getHours(!0), this.getMinutes(!0)];
            return t && e.push(this.getSeconds(!0)),
            this.digitize(e)
        },
        getDays: function(t) {
            var e = this.getTimeSeconds() / 60 / 60 / 24;
            return t && (e %= 7),
            Math.floor(e)
        },
        getHourCounter: function() {
            return this.digitize([this.getHours(), this.getMinutes(!0), this.getSeconds(!0)])
        },
        getHourly: function() {
            return this.getHourCounter()
        },
        getHours: function(t) {
            var e = this.getTimeSeconds() / 60 / 60;
            return t && (e %= 24),
            Math.floor(e)
        },
        getMilitaryTime: function(t, e) {
            void 0 === e && (e = !0),
            t || (t = this.getDateObject());
            var n = [t.getHours(), t.getMinutes()];
            return !0 === e && n.push(t.getSeconds()),
            this.digitize(n)
        },
        getMinutes: function(t) {
            var e = this.getTimeSeconds() / 60;
            return t && (e %= 60),
            Math.floor(e)
        },
        getMinuteCounter: function() {
            return this.digitize([this.getMinutes(), this.getSeconds(!0)])
        },
        getTimeSeconds: function(t) {
            return t || (t = new Date),
            this.time instanceof Date ? this.factory.countdown ? Math.max(this.time.getTime() / 1e3 - t.getTime() / 1e3, 0) : t.getTime() / 1e3 - this.time.getTime() / 1e3 : this.time
        },
        getTime: function(t, e) {
            void 0 === e && (e = !0),
            t || (t = this.getDateObject()),
            console.log(t);
            var n = t.getHours()
              , i = [n > 12 ? n - 12 : 0 === n ? 12 : n, t.getMinutes()];
            return !0 === e && i.push(t.getSeconds()),
            this.digitize(i)
        },
        getSeconds: function(t) {
            var e = this.getTimeSeconds();
            return t && (60 == e ? e = 0 : e %= 60),
            Math.ceil(e)
        },
        getWeeks: function(t) {
            var e = this.getTimeSeconds() / 60 / 60 / 24 / 7;
            return t && (e %= 52),
            Math.floor(e)
        },
        removeLeadingZeros: function(e, n) {
            var i = 0
              , r = [];
            return t.each(n, function(t, o) {
                e > t ? i += parseInt(n[t], 10) : r.push(n[t])
            }),
            0 === i ? r : n
        },
        addSeconds: function(t) {
            this.time instanceof Date ? this.time.setSeconds(this.time.getSeconds() + t) : this.time += t
        },
        addSecond: function() {
            this.addSeconds(1)
        },
        subSeconds: function(t) {
            this.time instanceof Date ? this.time.setSeconds(this.time.getSeconds() - t) : this.time -= t
        },
        subSecond: function() {
            this.subSeconds(1)
        },
        toString: function() {
            return this.getTimeSeconds().toString()
        }
    })
}(jQuery),
function(t) {
    "use strict";
    FlipClock.Timer = FlipClock.Base.extend({
        callbacks: {
            destroy: !1,
            create: !1,
            init: !1,
            interval: !1,
            start: !1,
            stop: !1,
            reset: !1
        },
        count: 0,
        factory: !1,
        interval: 1e3,
        animationRate: 1e3,
        constructor: function(t, e) {
            this.base(e),
            this.factory = t,
            this.callback(this.callbacks.init),
            this.callback(this.callbacks.create)
        },
        getElapsed: function() {
            return this.count * this.interval
        },
        getElapsedTime: function() {
            return new Date(this.time + this.getElapsed())
        },
        reset: function(t) {
            clearInterval(this.timer),
            this.count = 0,
            this._setInterval(t),
            this.callback(this.callbacks.reset)
        },
        start: function(t) {
            this.factory.running = !0,
            this._createTimer(t),
            this.callback(this.callbacks.start)
        },
        stop: function(t) {
            this.factory.running = !1,
            this._clearInterval(t),
            this.callback(this.callbacks.stop),
            this.callback(t)
        },
        _clearInterval: function() {
            clearInterval(this.timer)
        },
        _createTimer: function(t) {
            this._setInterval(t)
        },
        _destroyTimer: function(t) {
            this._clearInterval(),
            this.timer = !1,
            this.callback(t),
            this.callback(this.callbacks.destroy)
        },
        _interval: function(t) {
            this.callback(this.callbacks.interval),
            this.callback(t),
            this.count++
        },
        _setInterval: function(t) {
            var e = this;
            e._interval(t),
            e.timer = setInterval(function() {
                e._interval(t)
            }, this.interval)
        }
    })
}(jQuery),
function(t) {
    FlipClock.TwentyFourHourClockFace = FlipClock.Face.extend({
        constructor: function(t, e) {
            this.base(t, e)
        },
        build: function(e) {
            var n = this
              , i = this.factory.$el.find("ul");
            this.factory.time.time || (this.factory.original = new Date,
            this.factory.time = new FlipClock.Time(this.factory,this.factory.original)),
            (e = e || this.factory.time.getMilitaryTime(!1, this.showSeconds)).length > i.length && t.each(e, function(t, e) {
                n.createList(e)
            }),
            this.createDivider(),
            this.createDivider(),
            t(this.dividers[0]).insertBefore(this.lists[this.lists.length - 2].$el),
            t(this.dividers[1]).insertBefore(this.lists[this.lists.length - 4].$el),
            this.base()
        },
        flip: function(t, e) {
            this.autoIncrement(),
            t = t || this.factory.time.getMilitaryTime(!1, this.showSeconds),
            this.base(t, e)
        }
    })
}(jQuery),
function(t) {
    FlipClock.CounterFace = FlipClock.Face.extend({
        shouldAutoIncrement: !1,
        constructor: function(t, e) {
            "object" != typeof e && (e = {}),
            t.autoStart = !!e.autoStart,
            e.autoStart && (this.shouldAutoIncrement = !0),
            t.increment = function() {
                t.countdown = !1,
                t.setTime(t.getTime().getTimeSeconds() + 1)
            }
            ,
            t.decrement = function() {
                t.countdown = !0;
                var e = t.getTime().getTimeSeconds();
                e > 0 && t.setTime(e - 1)
            }
            ,
            t.setValue = function(e) {
                t.setTime(e)
            }
            ,
            t.setCounter = function(e) {
                t.setTime(e)
            }
            ,
            this.base(t, e)
        },
        build: function() {
            var e = this
              , n = this.factory.$el.find("ul")
              , i = this.factory.getTime().digitize([this.factory.getTime().time]);
            i.length > n.length && t.each(i, function(t, n) {
                e.createList(n).select(n)
            }),
            t.each(this.lists, function(t, e) {
                e.play()
            }),
            this.base()
        },
        flip: function(t, e) {
            this.shouldAutoIncrement && this.autoIncrement(),
            t || (t = this.factory.getTime().digitize([this.factory.getTime().time])),
            this.base(t, e)
        },
        reset: function() {
            this.factory.time = new FlipClock.Time(this.factory,this.factory.original ? Math.round(this.factory.original) : 0),
            this.flip()
        }
    })
}(jQuery),
function(t) {
    FlipClock.DailyCounterFace = FlipClock.Face.extend({
        showSeconds: !0,
        constructor: function(t, e) {
            this.base(t, e)
        },
        build: function(e) {
            var n = this
              , i = this.factory.$el.find("ul")
              , r = 0;
            (e = e || this.factory.time.getDayCounter(this.showSeconds)).length > i.length && t.each(e, function(t, e) {
                n.createList(e)
            }),
            this.showSeconds ? t(this.createDivider("Seconds")).insertBefore(this.lists[this.lists.length - 2].$el) : r = 2,
            t(this.createDivider("Minutes")).insertBefore(this.lists[this.lists.length - 4 + r].$el),
            t(this.createDivider("Hours")).insertBefore(this.lists[this.lists.length - 6 + r].$el),
            t(this.createDivider("Days", !0)).insertBefore(this.lists[0].$el),
            this.base()
        },
        flip: function(t, e) {
            t || (t = this.factory.time.getDayCounter(this.showSeconds)),
            this.autoIncrement(),
            this.base(t, e)
        }
    })
}(jQuery),
function(t) {
    FlipClock.HourlyCounterFace = FlipClock.Face.extend({
        constructor: function(t, e) {
            this.base(t, e)
        },
        build: function(e, n) {
            var i = this
              , r = this.factory.$el.find("ul");
            (n = n || this.factory.time.getHourCounter()).length > r.length && t.each(n, function(t, e) {
                i.createList(e)
            }),
            t(this.createDivider("Seconds")).insertBefore(this.lists[this.lists.length - 2].$el),
            t(this.createDivider("Minutes")).insertBefore(this.lists[this.lists.length - 4].$el),
            e || t(this.createDivider("Hours", !0)).insertBefore(this.lists[0].$el),
            this.base()
        },
        flip: function(t, e) {
            t || (t = this.factory.time.getHourCounter()),
            this.autoIncrement(),
            this.base(t, e)
        },
        appendDigitToClock: function(t) {
            this.base(t),
            this.dividers[0].insertAfter(this.dividers[0].next())
        }
    })
}(jQuery),
jQuery,
FlipClock.MinuteCounterFace = FlipClock.HourlyCounterFace.extend({
    clearExcessDigits: !1,
    constructor: function(t, e) {
        this.base(t, e)
    },
    build: function() {
        this.base(!0, this.factory.time.getMinuteCounter())
    },
    flip: function(t, e) {
        t || (t = this.factory.time.getMinuteCounter()),
        this.base(t, e)
    }
}),
function(t) {
    FlipClock.TwelveHourClockFace = FlipClock.TwentyFourHourClockFace.extend({
        meridium: !1,
        meridiumText: "AM",
        build: function() {
            var e = this.factory.time.getTime(!1, this.showSeconds);
            this.base(e),
            this.meridiumText = this.getMeridium(),
            this.meridium = t(['<ul class="flip-clock-meridium">', "<li>", '<a href="#">' + this.meridiumText + "</a>", "</li>", "</ul>"].join("")),
            this.meridium.insertAfter(this.lists[this.lists.length - 1].$el)
        },
        flip: function(t, e) {
            this.meridiumText != this.getMeridium() && (this.meridiumText = this.getMeridium(),
            this.meridium.find("a").html(this.meridiumText)),
            this.base(this.factory.time.getTime(!1, this.showSeconds), e)
        },
        getMeridium: function() {
            return (new Date).getHours() >= 12 ? "PM" : "AM"
        },
        isPM: function() {
            return "PM" == this.getMeridium()
        },
        isAM: function() {
            return "AM" == this.getMeridium()
        }
    })
}(jQuery),
jQuery,
FlipClock.Lang.Arabic = {
    years: "سنوات",
    months: "شهور",
    days: "أيام",
    hours: "ساعات",
    minutes: "دقائق",
    seconds: "ثواني"
},
FlipClock.Lang.ar = FlipClock.Lang.Arabic,
FlipClock.Lang["ar-ar"] = FlipClock.Lang.Arabic,
FlipClock.Lang.arabic = FlipClock.Lang.Arabic,
jQuery,
FlipClock.Lang.Danish = {
    years: "År",
    months: "Måneder",
    days: "Dage",
    hours: "Timer",
    minutes: "Minutter",
    seconds: "Sekunder"
},
FlipClock.Lang.da = FlipClock.Lang.Danish,
FlipClock.Lang["da-dk"] = FlipClock.Lang.Danish,
FlipClock.Lang.danish = FlipClock.Lang.Danish,
jQuery,
FlipClock.Lang.German = {
    years: "Jahre",
    months: "Monate",
    days: "Tage",
    hours: "Stunden",
    minutes: "Minuten",
    seconds: "Sekunden"
},
FlipClock.Lang.de = FlipClock.Lang.German,
FlipClock.Lang["de-de"] = FlipClock.Lang.German,
FlipClock.Lang.german = FlipClock.Lang.German,
jQuery,
FlipClock.Lang.English = {
    years: "Years",
    months: "Months",
    days: "Days",
    hours: "Hours",
    minutes: "Minutes",
    seconds: "Seconds"
},
FlipClock.Lang.en = FlipClock.Lang.English,
FlipClock.Lang["en-us"] = FlipClock.Lang.English,
FlipClock.Lang.english = FlipClock.Lang.English,
jQuery,
FlipClock.Lang.Spanish = {
    years: "Años",
    months: "Meses",
    days: "Días",
    hours: "Horas",
    minutes: "Minutos",
    seconds: "Segundos"
},
FlipClock.Lang.es = FlipClock.Lang.Spanish,
FlipClock.Lang["es-es"] = FlipClock.Lang.Spanish,
FlipClock.Lang.spanish = FlipClock.Lang.Spanish,
jQuery,
FlipClock.Lang.Finnish = {
    years: "Vuotta",
    months: "Kuukautta",
    days: "Päivää",
    hours: "Tuntia",
    minutes: "Minuuttia",
    seconds: "Sekuntia"
},
FlipClock.Lang.fi = FlipClock.Lang.Finnish,
FlipClock.Lang["fi-fi"] = FlipClock.Lang.Finnish,
FlipClock.Lang.finnish = FlipClock.Lang.Finnish,
jQuery,
FlipClock.Lang.French = {
    years: "Ans",
    months: "Mois",
    days: "Jours",
    hours: "Heures",
    minutes: "Minutes",
    seconds: "Secondes"
},
FlipClock.Lang.fr = FlipClock.Lang.French,
FlipClock.Lang["fr-ca"] = FlipClock.Lang.French,
FlipClock.Lang.french = FlipClock.Lang.French,
jQuery,
FlipClock.Lang.Italian = {
    years: "Anni",
    months: "Mesi",
    days: "Giorni",
    hours: "Ore",
    minutes: "Minuti",
    seconds: "Secondi"
},
FlipClock.Lang.it = FlipClock.Lang.Italian,
FlipClock.Lang["it-it"] = FlipClock.Lang.Italian,
FlipClock.Lang.italian = FlipClock.Lang.Italian,
jQuery,
FlipClock.Lang.Latvian = {
    years: "Gadi",
    months: "Mēneši",
    days: "Dienas",
    hours: "Stundas",
    minutes: "Minūtes",
    seconds: "Sekundes"
},
FlipClock.Lang.lv = FlipClock.Lang.Latvian,
FlipClock.Lang["lv-lv"] = FlipClock.Lang.Latvian,
FlipClock.Lang.latvian = FlipClock.Lang.Latvian,
jQuery,
FlipClock.Lang.Dutch = {
    years: "Jaren",
    months: "Maanden",
    days: "Dagen",
    hours: "Uren",
    minutes: "Minuten",
    seconds: "Seconden"
},
FlipClock.Lang.nl = FlipClock.Lang.Dutch,
FlipClock.Lang["nl-be"] = FlipClock.Lang.Dutch,
FlipClock.Lang.dutch = FlipClock.Lang.Dutch,
jQuery,
FlipClock.Lang.Norwegian = {
    years: "År",
    months: "Måneder",
    days: "Dager",
    hours: "Timer",
    minutes: "Minutter",
    seconds: "Sekunder"
},
FlipClock.Lang.no = FlipClock.Lang.Norwegian,
FlipClock.Lang.nb = FlipClock.Lang.Norwegian,
FlipClock.Lang["no-nb"] = FlipClock.Lang.Norwegian,
FlipClock.Lang.norwegian = FlipClock.Lang.Norwegian,
jQuery,
FlipClock.Lang.Portuguese = {
    years: "Anos",
    months: "Meses",
    days: "Dias",
    hours: "Horas",
    minutes: "Minutos",
    seconds: "Segundos"
},
FlipClock.Lang.pt = FlipClock.Lang.Portuguese,
FlipClock.Lang["pt-br"] = FlipClock.Lang.Portuguese,
FlipClock.Lang.portuguese = FlipClock.Lang.Portuguese,
jQuery,
FlipClock.Lang.Russian = {
    years: "лет",
    months: "месяцев",
    days: "дней",
    hours: "часов",
    minutes: "минут",
    seconds: "секунд"
},
FlipClock.Lang.ru = FlipClock.Lang.Russian,
FlipClock.Lang["ru-ru"] = FlipClock.Lang.Russian,
FlipClock.Lang.russian = FlipClock.Lang.Russian,
jQuery,
FlipClock.Lang.Swedish = {
    years: "År",
    months: "Månader",
    days: "Dagar",
    hours: "Timmar",
    minutes: "Minuter",
    seconds: "Sekunder"
},
FlipClock.Lang.sv = FlipClock.Lang.Swedish,
FlipClock.Lang["sv-se"] = FlipClock.Lang.Swedish,
FlipClock.Lang.swedish = FlipClock.Lang.Swedish,
jQuery,
FlipClock.Lang.Chinese = {
    years: "年",
    months: "月",
    days: "日",
    hours: "时",
    minutes: "分",
    seconds: "秒"
},
FlipClock.Lang.zh = FlipClock.Lang.Chinese,
FlipClock.Lang["zh-cn"] = FlipClock.Lang.Chinese,
FlipClock.Lang.chinese = FlipClock.Lang.Chinese;
var jQ = jQuery.noConflict(!0)
  , GPOApp = GPOApp || {};
GPOApp.appUrl = "//app.shopifydevelopers.net/pre-order/",
GPOApp.initSelector = function() {
    GPOParams.line_property_name = GPOParams.hasOwnProperty("line_property_name") ? GPOParams.line_property_name : "Pre-ordered items",
    GPOParams.preorder_avaiable_message = GPOParams.hasOwnProperty("preorder_avaiable_message") ? GPOParams.preorder_avaiable_message : "",
    jQ("form[action*='cart']:visible .product__add-to-cart-button").length ? GPOParams.addtocart_selector = "form[action*='cart']:visible .product__add-to-cart-button" : jQ("#AddToCart--product-template").length ? GPOParams.addtocart_selector = "#AddToCart--product-template" : jQ("#addToCart").length ? GPOParams.addtocart_selector = "#addToCart" : jQ("#AddToCart-product-template").length ? GPOParams.addtocart_selector = "#AddToCart-product-template" : jQ("#AddToCart").length ? GPOParams.addtocart_selector = "#AddToCart" : jQ("#AddToCart-").length ? GPOParams.addtocart_selector = "#AddToCart-" : jQ("form[action*='cart']:visible .add_to_cart").length ? GPOParams.addtocart_selector = "form[action*='cart']:visible .add_to_cart" : jQ("form[action*='cart']:visible .product-form--atc-button").length ? GPOParams.addtocart_selector = "form[action*='cart']:visible .product-form--atc-button" : jQ("#AddToCart-product").length ? GPOParams.addtocart_selector = "#AddToCart-product" : jQ(".AddtoCart").length ? GPOParams.addtocart_selector = ".AddtoCart" : jQ("form[action*='cart']:visible #add").length ? GPOParams.addtocart_selector = "form[action*='cart']:visible #add" : jQ("form[action*='cart']:visible [name='add']").length ? GPOParams.addtocart_selector = "form[action*='cart']:visible [name='add']" : jQ("form[action*='cart']:visible [type='submit']").length ? GPOParams.addtocart_selector = "form[action*='cart']:visible [type='submit']" : jQ("form[action*='cart']:visible [type='button']").length ? GPOParams.addtocart_selector = "form[action*='cart']:visible [type='button']" : jQ("form[action*='cart']:visible button").length ? GPOParams.addtocart_selector = "form[action*='cart']:visible button" : jQ("form[action*='cart']:visible button.btn-addtocart").length ? GPOParams.addtocart_selector = "form[action*='cart']:visible button.btn-addtocart" : console.log('Not Define "Add to cart" selector')
}
,
GPOApp.init = function() {
    var t = this;
    GPOApp.initSelector(),
    jQ(document).ready(function() {
        var e = !1;
        if (jQ("script").each(function() {
            -1 != jQ(this).text().indexOf("globopreorder_init.js?") && -1 != jQ(this).text().indexOf("asyncLoad") && -1 == jQ(this).text().indexOf("initSchema") && (e = !0)
        }),
        "undefined" != typeof GPOParams && e)
            if (t.initCollection(),
            window.addEventListener("globoFilterRenderCompleted", function() {
                t.initCollection()
            }),
            "product" == GPOApp.getPageType() && "undefined" != typeof GPOProduct)
                GPOApp.updateVariant(GPOProduct.selected_variant, GPOProduct.product),
                jQ(document).on("change", "[data-product-option], .SizeSwatchList input, .variant-input-wrap input ,[name=id], #product-select-" + GPOProduct.product.id + ", .single-option-selector,.swatch input,.swatch-panda input[type=radio],.swatch-element input[type=radio],select[id|='product-select-" + GPOProduct.product.id + "-option'],select[id|='product-select-option'],[id|='productSelect-product'],[id|='ProductSelect-option'],select[id|='product-variants-option'],select[id|='sca-qv-product-selected-option'],select[id|='product-variants-" + GPOProduct.product.id + "-option'],select[id|='product-selectors-option'],select[id|='variant-listbox-option'],select[id|='product-select-" + GPOProduct.product.id + "product-option'],select[id|='id-option'],select[id|='SingleOptionSelector'],select[id|='product-select-" + GPOProduct.product.id + "'][name=id]", function() {
                    GPOApp.updateVariant(0, GPOProduct.product)
                }),
                jQ(document).on("click", ".swatchColor, .swatches > ul > li > a, .tt-options-swatch li a, .product-options__value", function() {
                    GPOApp.updateVariant(0, GPOProduct.product)
                });
            else if ("cart" == GPOApp.getPageType()) {
                var n = GPOApp.findElementByText("_is_preorder");
                jQ(n).each(function() {
                    "GPO_script" != jQ(this).attr("id") && jQ(this).html(jQ(this).html().replace("_is_preorder:", "").replace("_is_preorder", ""))
                }),
                jQ("form[action*='cart'] [type='submit'], form[action*='checkout'] [type='submit']").click(function() {
                    jQ("form[action*='cart'] [type='submit'], form[action*='checkout'] [type='submit']").attr("clicked", !1),
                    jQ(this).attr("clicked", !0)
                }),
                jQ("form[action*='cart'], form[action*='checkout']").submit(function(t) {
                    var e;
                    e = jQ(this).find("[type='submit'][clicked=true]").val().toLowerCase();
                    var n = ""
                      , i = []
                      , r = {};
                    r._is_preorder = GPOParams.line_property_name;
                    var o = jQ("[name*=updates]").serializeArray();
                    if (jQ(o).each(function(t, e) {
                        if (e.value != GPOCart.items[t].quantity && GPOApp.isPreOrderVariant(GPOCart.items[t].product_id, GPOCart.items[t].variant_id)) {
                            var r = e.value
                              , o = null == GPOCart.items[t].variant.inventory_quantity ? 0 : parseInt(GPOCart.items[t].variant.inventory_quantity)
                              , a = GPOApp.getVariantOrProductOrDefault(GPOParams, "products", GPOCart.items[t].product_id, "variants", GPOCart.items[t].variant_id, "limit", 0)
                              , s = GPOCart.items[t].variant.name;
                            if (a > 0 && a + o - r < 0) {
                                r = a + o,
                                jQ("[name*=updates]").eq(t).val(r);
                                var c = GPOParams.preorder_stock_limited_message;
                                void 0 !== c && c.length && (c = c.replace(":stock", r),
                                n += s + ": " + c + "\r\n")
                            } else if (o > 0 && r > o) {
                                var u = GPOParams.preorder_confirm_message;
                                void 0 !== u && u.length && (u = u.replace(":stock", o),
                                n += s + ": " + u + "\r\n")
                            }
                            r > o ? i.push({
                                id: GPOCart.items[t].id,
                                variant_id: GPOCart.items[t].variant_id,
                                qty: r,
                                is_preorder: !0
                            }) : i.push({
                                id: GPOCart.items[t].id,
                                variant_id: GPOCart.items[t].variant_id,
                                qty: r,
                                is_preorder: !1
                            })
                        }
                    }),
                    i.length > 0 && (t.preventDefault(),
                    0 == n.length || n.length && confirm(n)))
                        for (var a = 0; a < i.length; a++)
                            if (i[a].is_preorder != GPOCart.items[a].is_preorder) {
                                var s = {};
                                s.quantity = i[a].qty,
                                s.id = i[a].variant_id,
                                i[a].is_preorder && (s.properties = r),
                                (c = {})[i[a].id] = 0,
                                jQ.ajax({
                                    type: "POST",
                                    url: "/cart/update.js",
                                    data: {
                                        updates: c
                                    },
                                    dataType: "json",
                                    success: function() {
                                        jQ.ajax({
                                            type: "POST",
                                            url: "/cart/add.js",
                                            data: s,
                                            dataType: "json",
                                            success: function() {
                                                "update" == e ? location.reload() : window.location.href = "/checkout"
                                            },
                                            error: function(t, e, n) {
                                                jsonValue = jQuery.parseJSON(t.responseText),
                                                alert(jsonValue.description)
                                            }
                                        })
                                    },
                                    error: function(t, e, n) {
                                        jsonValue = jQuery.parseJSON(t.responseText),
                                        alert(jsonValue.description)
                                    }
                                })
                            } else {
                                var c;
                                (c = {})[i[a].id] = i[a].qty,
                                jQ.ajax({
                                    type: "POST",
                                    url: "/cart/update.js",
                                    data: {
                                        updates: c
                                    },
                                    dataType: "json",
                                    success: function() {
                                        "update" == e ? location.reload() : window.location.href = "/checkout"
                                    },
                                    error: function(t, e, n) {
                                        jsonValue = jQuery.parseJSON(t.responseText),
                                        jsonValue.description && alert(jsonValue.description)
                                    }
                                })
                            }
                })
            }
    })
}
,
GPOApp.initCollection = function() {
    jQ(".product-script-item").length > 0 && (jQ(".product-script-item").each(function() {
        var t = [".add-to-cart-btn", ".product__add-to-cart-button", "input[type=submit]", "button[type=submit]"];
        if (jQ(this).parent().find('form [name="id"]').length) {
            var e = jQ(this).parent().find("form")
              , n = jQ(this).parent().find('form [name="id"]').val()
              , i = jQ(this).attr("id")
              , r = !1
              , o = GPOApp.getVariantOrProductOrDefault(GPOParams, "products", i, "variants", n, "status", !1)
              , a = GPOApp.getVariantOrProductOrDefault(GPOParams, "products", i, "variants", n, "button_text", GPOParams.button_title || "")
              , s = GPOApp.getVariantOrProductOrDefault(GPOParams, "products", i, "variants", n, "not_available_message", GPOParams.not_available_message);
            jQ.each(t, function(t, n) {
                e.find(n).length && (e.find(n).is(":button") ? e.find(n).attr("data-add-text", e.find(n).val().trim()).attr("data-pre-text", a).attr("data-na-text", s) : e.find(n).attr("data-add-text", e.find(n).text().trim()).attr("data-pre-text", a).attr("data-na-text", s))
            }),
            jQ.each(GPOCollectionParams[i].variants, function(t, e) {
                var i = null == e.inventory_quantity ? 0 : parseInt(e.inventory_quantity);
                e.id == n && i <= 0 && (r = !0)
            }),
            o && r ? GPOApp.isPreOrderVariant(i, n) ? (console.log("Show Pre order"),
            0 == e.find(".properties_is_preorder").length && e.append('<input type="hidden" class="properties_is_preorder" name="properties[_is_preorder]" value="' + GPOParams.line_property_name + '" />'),
            jQ.each(t, function(t, n) {
                e.find(n).length && (e.find(n).is(":button") ? e.find(n).prop("disabled", !1).text(a) : e.find(n).prop("disabled", !1).val(a))
            })) : (console.log("Show NA message"),
            jQ.each(t, function(t, n) {
                e.find(n).length && (e.find(n).is(":button") ? e.find(n).prop("disabled", !0).text(s) : e.find(n).prop("disabled", !0).val(s))
            })) : (console.log("Show Default Button"),
            jQ.each(t, function(t, n) {
                e.find(n).length && (e.find(n).is(":button") ? e.find(n).prop("disabled", !1).text(e.find(n).attr("data-add-text")) : e.find(n).prop("disabled", !1).val(e.find(n).attr("data-add-text")))
            }),
            e.find(".properties_is_preorder").remove()),
            e.on("change", ".SizeSwatchList input, .single-option-selector,.swatch-panda input[type=radio],.swatch input,.swatch-element input[type=radio],select[id|='product-select-" + i + "-option'],select[id|='product-select-option'],[id|='productSelect-product'],[id|='ProductSelect-option'],select[id|='product-variants-option'],select[id|='sca-qv-product-selected-option'],select[id|='product-variants-" + i + "-option'],select[id|='product-selectors-option'],select[id|='variant-listbox-option'],select[id|='product-select-" + i + "product-option'],select[id|='id-option'],select[id|='SingleOptionSelector'],select[id|='product-select-" + i + "'][name=id]", function() {
                var n = e.find('[name="id"]').val()
                  , r = !1
                  , o = GPOApp.getVariantOrProductOrDefault(GPOParams, "products", i, "variants", n, "status", !1)
                  , a = GPOApp.getVariantOrProductOrDefault(GPOParams, "products", i, "variants", n, "button_text", GPOParams.button_title || "")
                  , s = GPOApp.getVariantOrProductOrDefault(GPOParams, "products", i, "variants", n, "not_available_message", GPOParams.not_available_message);
                jQ.each(GPOCollectionParams[i].variants, function(t, e) {
                    var i = null == e.inventory_quantity ? 0 : parseInt(e.inventory_quantity);
                    e.id == n && i <= 0 && (r = !0)
                }),
                o && r ? GPOApp.isPreOrderVariant(i, n) ? (0 == e.find(".properties_is_preorder").length && e.append('<input type="hidden" class="properties_is_preorder" name="properties[_is_preorder]" value="' + GPOParams.line_property_name + '" />'),
                jQ.each(t, function(t, n) {
                    e.find(n).length && (e.find(n).is(":button") ? e.find(n).prop("disabled", !1).text(a) : e.find(n).prop("disabled", !1).val(a))
                })) : jQ.each(t, function(t, n) {
                    e.find(n).length && (e.find(n).is(":button") ? e.find(n).prop("disabled", !0).text(s) : e.find(n).prop("disabled", !0).val(s))
                }) : (jQ.each(t, function(t, n) {
                    e.find(n).length && (e.find(n).is(":button") ? e.find(n).prop("disabled", !1).text(e.find(n).attr("data-add-text")) : e.find(n).prop("disabled", !1).val(e.find(n).attr("data-add-text")))
                }),
                e.find(".properties_is_preorder").remove())
            })
        }
    }),
    jQ(gpoProduct.getQuichViewButtonSelector()).length ? jQ(document).ready(function() {
        jQ(".product-script-item").parent().addClass("gpo-product-item"),
        GPOParams.quickview_button_selector = gpoProduct.getQuichViewButtonSelector(),
        jQ(GPOParams.quickview_button_selector).on("click", function() {
            var t = jQ(this).closest(".gpo-product-item").find(".product-script-item").attr("id");
            t ? (GPOParams.quickview_selector = gpoProduct.getQuichViewPopupSelector(t),
            gpoProduct.getProduct(t, function(t) {
                if (void 0 !== t.product)
                    var e = setInterval(function() {
                        jQ(GPOParams.quickview_selector).length && (gpoProduct.quickView(t.product),
                        clearInterval(e))
                    }, 500)
            })) : console.log("Not Define Product Handle: You haven't added attribute data-product-id for Quickview Button")
        })
    }) : console.log('Not Define ["Quick view" button selector], [Quick view variant selector]'))
}
,
GPOApp.addProductToCart = function(t, e, n, i, r) {
    var o = e.variants[n]
      , a = parseInt(GPOApp.getVariantOrProductOrDefault(GPOParams, "products", e.id, "variants", o.id, "limit", 0))
      , s = null == o.inventory_quantity ? 0 : parseInt(o.inventory_quantity);
    if (("continue" == o.inventory_policy || i > s) && !0,
    a > 0 && a + s - i < 0) {
        i = a + s,
        t.find('[name="quantity"]').val(i);
        var c = GPOParams.preorder_stock_limited_message;
        if (void 0 !== c && c.length)
            if (c = c.replace(":stock", i),
            0 == confirm(c))
                return !1
    } else if (s > 0 && i > s) {
        var u = GPOParams.preorder_confirm_message;
        if (void 0 !== u && u.length)
            if (u = u.replace(":stock", s),
            0 == confirm(u))
                return !1
    }
    i > 0 && jQ.ajax({
        type: "POST",
        url: "/cart/add.js",
        cache: !1,
        async: !1,
        dataType: "json",
        data: t.serialize(),
        error: function(t, e, n) {
            jsonValue = jQuery.parseJSON(t.responseText),
            alert(jsonValue.description)
        }
    }).done(function() {
        r()
    })
}
,
GPOApp.findElementByText = function(t) {
    return jQ("*:contains(" + t + "):last")
}
,
GPOApp.checkVariantSetting = function(t, e, n, i, r, o) {
    for (var a = Array.prototype.slice.call(arguments, 1), s = 0; s < a.length; s++) {
        if (!t || !t.hasOwnProperty(a[s]))
            return !1;
        t = t[a[s]]
    }
    return !0
}
,
GPOApp.checkProductSetting = function(t, e, n, i) {
    for (var r = Array.prototype.slice.call(arguments, 1), o = 0; o < r.length; o++) {
        if (!t || !t.hasOwnProperty(r[o]))
            return !1;
        t = t[r[o]]
    }
    return !0
}
,
GPOApp.getVariantOrProductOrDefault = function(t, e, n, i, r, o, a) {
    return GPOApp.checkVariantSetting(t, e, n, i, r, o) ? t[e][n][i][r][o] : a
}
,
GPOApp.isPreOrderProduct = function(t) {
    return !(!GPOApp.checkProductSetting(GPOParams, "products", t, "status") || 1 != GPOParams.products[t].status)
}
,
GPOApp.isPreOrderVariant = function(t, e) {
    var n = GPOApp.getVariantOrProductOrDefault(GPOParams, "products", t, "variants", e, "status", !1);
    if (0 == n || 0 == n || "0" == n)
        return !1;
    var i = new Date
      , r = GPOApp.getVariantOrProductOrDefault(GPOParams, "products", t, "variants", e, "started_at", !1);
    if (r && i.getTime() < r)
        return !1;
    var o = GPOApp.getVariantOrProductOrDefault(GPOParams, "products", t, "variants", e, "finished_at", !1);
    return !(o && i.getTime() > o)
}
,
GPOApp.updateVariant = function(t, e) {
    console.log("updateVariant");
    try {
        null != (t = t || GPOApp.getCurrentVariantId(e.id)) ? jQ.each(e.variants, function(n, i) {
            t == i.id && GPOApp.updateButton(i, e)
        }) : GPOApp.showStandardButton()
    } catch (t) {
        GPOApp.showStandardButton()
    }
}
,
GPOApp.getCurrentVariantId = function(t) {
    return jQ('form.ProductForm[action*="/cart"]:visible:first').length ? jQ('form.ProductForm[action*="/cart"]:visible:first').find("[name=id]").val() : jQ('form#AddToCartForm[action*="/cart"]:visible:first').length ? jQ('form#AddToCartForm[action*="/cart"]:visible:first').find("[name=id]").val() : jQ('form.product-form[action*="/cart"]:visible:first').length ? jQ('form.product-form[action*="/cart"]:visible:first').find("[name=id]").val() : jQ('form.product-form[action*="/cart"]:visible:first [name=variant_id]').length ? jQ('form.product-form[action*="/cart"]:visible:first [name=variant_id]').val() : jQ('form[action*="/cart"]:visible:first').length ? jQ('form[action*="/cart"]:visible:first').find("[name=id]").val() : jQ("[name=id]").val()
}
,
GPOApp.updateButton = function(t, e) {
    console.log("updateButton"),
    jQ("#GPO-countdown, #GPO-available-text, #pre-order, #gpo-na-message").hide(),
    jQ(".GPO_tooltip").remove();
    var n = null == t.inventory_quantity ? 0 : parseInt(t.inventory_quantity)
      , i = GPOApp.getVariantOrProductOrDefault(GPOParams, "products", e.id, "variants", t.id, "status", !1);
    if ((n <= 0 && "continue" == t.inventory_policy || "shopify" != t.inventory_management) && i) {
        var r = GPOApp.getVariantOrProductOrDefault(GPOParams, "products", e.id, "variants", t.id, "limit", 0);
        GPOApp.isPreOrderVariant(e.id, t.id) && (0 == r || 0 != r && -1 * parseInt(n) < r) ? (console.log("showPreOrderButton"),
        window.dispatchEvent(new Event("showPreOrderButton")),
        this.showPreOrderButton(t, e)) : (window.dispatchEvent(new Event("showNAMessage")),
        console.log("showNAMessage"),
        this.showNAMessage(t))
    } else
        console.log("showStandardButton"),
        window.dispatchEvent(new Event("showStandardButton")),
        GPOApp.showStandardButton()
}
,
GPOApp.showCountdown = function(t) {
    var e = GPOApp.getVariantOrProductOrDefault(GPOParams, "products", GPOProduct.product.id, "variants", t.id, "show_timer", !1)
      , n = new Date
      , i = GPOApp.getVariantOrProductOrDefault(GPOParams, "products", GPOProduct.product.id, "variants", t.id, "finished_at", !1);
    if (e && i) {
        console.log("showCountdown:" + t.id);
        var r = {
            weekday: "long",
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit"
        };
        jQ(GPOParams.addtocart_selector).first().css("display", "none"),
        jQ("#gpo-na-message").hide();
        var o = i - n.getTime();
        if (o > 0) {
            jQ("#GPO-countdown").length || (jQ(GPOParams.addtocart_selector).first().parent().is("form") ? jQ('<div id="GPO-countdown"></div>').insertAfter(jQ("#pre-order").first()) : jQ('<div id="GPO-countdown"></div>').insertAfter(jQ("#pre-order").first().parent()));
            var a = GPOApp.getVariantOrProductOrDefault(GPOParams, "products", GPOProduct.product.id, "variants", t.id, "available_auto", !1)
              , s = GPOApp.getVariantOrProductOrDefault(GPOParams, "products", GPOProduct.product.id, "variants", t.id, "available_at", !1);
            if (a && s && GPOParams.preorder_avaiable_message.length) {
                var c = new Date(s);
                jQ("#GPO-available-text").length ? jQ("#GPO-available-text").text(GPOParams.preorder_avaiable_message + " " + c.toLocaleString("en-us", r)).show() : jQ('<p id="GPO-available-text">' + GPOParams.preorder_avaiable_message + " " + c.toLocaleString("en-us", r) + "</p>").insertAfter("#GPO-countdown")
            }
            jQ("#GPO-countdown").FlipClock(o / 1e3, {
                clockFace: "DailyCounter",
                countdown: !0,
                callbacks: {
                    stop: function() {
                        location.reload()
                    }
                }
            }),
            jQ("#GPO-countdown").show()
        }
    }
}
,
GPOApp.showPreOrderButton = function(t, e) {
    jQ(".GPO_tooltip").remove(),
    jQ("body").addClass("isPreOrderProduct"),
    jQ("#gpo-na-message, #GPO-countdown, #GPO-available-text").hide();
    var n = GPOApp.getVariantOrProductOrDefault(GPOParams, "products", e.id, "variants", t.id, "button_text", GPOParams.button_title || "")
      , i = GPOApp.getVariantOrProductOrDefault(GPOParams, "products", e.id, "variants", t.id, "button_description", GPOParams.button_description || "");
    0 == jQ("#pre-order").length ? jQ(GPOParams.addtocart_selector).length > 0 ? jQ(GPOParams.addtocart_selector).first().clone().insertAfter(jQ(GPOParams.addtocart_selector).first()).removeClass("add_to_cart add product__add-to-cart bold_hidden hide-cart-button").attr("id", "pre-order").removeAttr("name") : jQ('<input type="button" value="' + n + '" id="pre-order"/>').appendTo("form[action*='cart'], form[action*='checkout']") : jQ("#pre-order").removeClass("add_to_cart add product__add-to-cart bold_hidden hide-cart-button").attr("id", "pre-order").removeAttr("name"),
    jQ("#pre-order").hasClass("addtocart-js") && jQ("#pre-order").hasClass("btn-addtocart") && jQ("#pre-order").removeClass("btn-addtocart"),
    jQ("#pre-order").is("input") ? jQ("#pre-order").val(n) : jQ("#pre-order").html(n),
    i.length > 0 && jQ("#pre-order").unbind("hover").hover(function() {
        var t = jQ("#pre-order").offset().top
          , e = jQ("#pre-order").outerWidth()
          , n = jQ("#pre-order").offset().left
          , r = (jQ("#pre-order").outerHeight(),
        parseInt(jQ("html").css("padding-top")));
        jQ('<div class="GPO_tooltip tooltip_top" ' + ('style="left:' + (n + e / 2) + "px; top:" + (t - r) + 'px"') + ">" + i + "</div>").appendTo("body").fadeIn()
    }, function() {
        jQ(".GPO_tooltip").fadeOut(300, function() {
            jQ(".GPO_tooltip").remove()
        })
    }),
    jQ(GPOParams.addtocart_selector).addClass("gpo-hidden"),
    jQ("#pre-order").first().show().prop("disabled", !1).removeClass("disabled gpo-hidden"),
    0 == jQ("#pre-order").closest("form").find("#preorder_hidden_input").length && jQ('<input type="hidden" id="preorder_hidden_input" name="properties[_is_preorder]" value="' + GPOParams.line_property_name + '" />').insertBefore("#pre-order"),
//     jQ("#pre-order").off("click").unbind("click").click(function() {
//         var t = jQ(this).closest("form[action*='cart'], form[action*='checkout']")
//           , n = t.find("[name=quantity]").length ? t.find("[name=quantity]").val() : 1
//           , i = t.find("[name=id]").length ? t.find("[name=id]").val() : 0;
//         GPOApp.addProductToCart(t, e, i, n, function() {
//             "undefined" != typeof GPOAddToCartCallback ? GPOAddToCartCallback() : window.location.href = "/cart"
//         })
//     }),
    this.showCountdown(t)
}
,
GPOApp.showStandardButton = function() {
    jQ(".GPO_tooltip, #preorder_hidden_input").remove(),
    jQ("body").removeClass("isPreOrderProduct isPONA"),
    jQ(GPOParams.addtocart_selector).removeClass("gpo-hidden").show(),
    jQ("#pre-order, #GPO-countdown, #gpo-na-message").hide()
}
,
GPOApp.showNAMessage = function(t) {
    jQ("body").addClass("isPreOrderProduct isPONA"),
    jQ(".GPO_tooltip, #preorder_hidden_input").remove(),
    jQ("#pre-order, #GPO-countdown").hide(),
    jQ(GPOParams.addtocart_selector).addClass("gpo-hidden");
    var e = GPOApp.getVariantOrProductOrDefault(GPOParams, "products", GPOProduct.product.id, "variants", t.id, "not_available_message", GPOParams.not_available_message);
    void 0 !== e && e.length && (jQ("#gpo-na-message").length > 0 ? (jQ("#gpo-na-message").html(e),
    jQ("#gpo-na-message").removeClass("gpo-hidden").show()) : jQ('<span id="gpo-na-message">' + e + "</span>").insertAfter(jQ(GPOParams.addtocart_selector).first()))
}
,
GPOApp.getPageType = function() {
    var t = window.location.toString();
    return null !== t.match(/\/products\//) || null !== t.match(/\/products_preview/) ? "product" : null !== t.match(/\/cart/) ? "cart" : null !== t.match(/\/collections\//) ? "collection" : ""
}
,
window.gpoProduct = {},
gpoProduct.getProduct = function(t, e) {
    if (Object.keys(GPOCollectionParams).length) {
        if (GPOCollectionParams.hasOwnProperty(t))
            return e({
                product: GPOCollectionParams[t]
            })
    } else
        console.log("Not Define: Quickview Product Data")
}
,
gpoProduct.getQuichViewButtonSelector = function() {
    return '.productitem--action-trigger, .quick-product__btn, a.quick_view, a.sca-qv-button, .quick_shop, .overlay, span.quick-view, a[rel="quick-view"], a.quick-buy, div.quickview-button > a, .block-inner a.more-info, a.product-modal, .quick-shop-modal-trigger, a.quick-view-btn, a.spo-quick-view, div.quickView-button, a.product__label--quick-shop, span.trigger-quick-view, a.act-quickview-button, a.product-modal'
}
,
gpoProduct.getQuichViewPopupSelector = function(t) {
    return ".modal--quickshop-full, .quickform, .product-quick-view , #colorbox, .quick-modal, .quick-shop, #product" + t + '__form, .quickView-wrap, .content.product.preview, .quick-view-panel, .quick-shop.active, .fancybox-outer, div[data-product-id="' + t + '"], #QuickShopModal-' + t + ", .quick-view, .white-popup.quick-view, .quick-shop, #quick-shop-modal"
}
,
gpoProduct.getQuichViewAddToCartSelector = function() {
    var t = jQ(GPOParams.quickview_selector).find("form[action*='cart'] [name='add'], form[action*='checkout'] [name='add']");
    return 0 == jQ(t).length && (t = jQ(GPOParams.quickview_selector).find("form[action*='cart'] [type='submit'], form[action*='checkout'] [type='submit']")),
    0 == jQ(t).length && (t = jQ(GPOParams.quickview_selector).find("form[action*='cart'] [type='button'], form[action*='checkout'] [type='button']")),
    t
}
,
gpoProduct.quickView = function(t) {
    function e() {
        vid = jQ(GPOParams.quickview_selector).find('[name="id"]').val(),
        jQ.each(t.variants, function(e, n) {
            if (n.id == vid) {
                var i = null == n.inventory_quantity ? 0 : parseInt(n.inventory_quantity);
                GPOApp.getVariantOrProductOrDefault(GPOParams, "products", t.id, "variants", n.id, "status", !1);
                if (i <= 0 && "continue" == n.inventory_policy || "shopify" != n.inventory_management) {
                    var r = GPOApp.getVariantOrProductOrDefault(GPOParams, "products", t.id, "variants", n.id, "limit", 0);
                    GPOApp.isPreOrderVariant(t.id, n.id) && (0 == r || 0 != r && -1 * parseInt(i) < r) ? (console.log("showQickviewPreOrderButton"),
                    gpoProduct.showQickviewPreOrderButton(n, t)) : (console.log("showQickviewNAMessage"),
                    gpoProduct.showQickviewNAMessage(n, t))
                } else
                    gpoProduct.showQickviewStandardButton(),
                    console.log("showQickviewStandardButton")
            }
        })
    }
    jQ(GPOParams.quickview_selector).find("form[action*='cart'] [name='add']").length ? GPOParams.quickview_addtocart_selector = jQ(GPOParams.quickview_selector).find("form[action*='cart'] [name='add']").first() : jQ(GPOParams.quickview_selector).find("form[action*='cart'] [type='submit']").length ? GPOParams.quickview_addtocart_selector = jQ(GPOParams.quickview_selector).find("form[action*='cart'] [type='submit']").first() : jQ(GPOParams.quickview_selector).find("form[action*='cart'] [type='button']").length ? GPOParams.quickview_addtocart_selector = jQ(GPOParams.quickview_selector).find("form[action*='cart'] [type='button']").first() : jQ(GPOParams.quickview_selector).find("[name='add']").length ? GPOParams.quickview_addtocart_selector = jQ(GPOParams.quickview_selector).find("[name='add']").first() : jQ(GPOParams.quickview_selector).find("[type='submit']").length ? GPOParams.quickview_addtocart_selector = jQ(GPOParams.quickview_selector).find("[type='submit']").first() : jQ(GPOParams.quickview_selector).find("[type='button']").length && (GPOParams.quickview_addtocart_selector = jQ(GPOParams.quickview_selector).find("[type='button']").first()),
    console.log(GPOParams.quickview_addtocart_selector);
    try {
        e(),
        jQ(GPOParams.quickview_selector).on("change", "input, select", function() {
            e()
        })
    } catch (t) {
        gpoProduct.showQickviewStandardButton()
    }
}
,
gpoProduct.showQickviewStandardButton = function() {
    jQ("#quick-pre-order, #GPO-quick-countdown, #gpo-quick-na-message, #GPO-quick-available-text").addClass("gpo-hidden"),
    jQ(".GPO_tooltip").remove(),
    GPOParams.quickview_addtocart_selector.removeClass("gpo-hidden")
}
,
gpoProduct.showQickviewNAMessage = function(t, e) {
    jQ(".GPO_tooltip").remove(),
    jQ("#quick-pre-order, #GPO-quick-countdown, #GPO-quick-available-text").addClass("gpo-hidden"),
    GPOParams.quickview_addtocart_selector.addClass("gpo-hidden");
    var n = GPOApp.getVariantOrProductOrDefault(GPOParams, "products", e.id, "variants", t.id, "not_available_message", GPOParams.not_available_message);
    void 0 !== n && n.length && (jQ("#gpo-quick-na-message").length > 0 ? (jQ("#gpo-quick-na-message").html(n),
    jQ("#gpo-quick-na-message").removeClass("gpo-hidden")) : jQ('<span id="gpo-quick-na-message">' + n + "</span>").insertAfter(GPOParams.quickview_addtocart_selector))
}
,
gpoProduct.showQickviewPreOrderButton = function(t, e) {
    GPOParams.quickview_addtocart_selector.addClass("gpo-hidden"),
    jQ(".GPO_tooltip").remove(),
    jQ("#gpo-quick-na-message, #GPO-quick-countdown, #GPO-quick-available-text").addClass("gpo-hidden");
    var n = GPOApp.getVariantOrProductOrDefault(GPOParams, "products", e.id, "variants", t.id, "button_text", GPOParams.button_title || "")
      , i = GPOApp.getVariantOrProductOrDefault(GPOParams, "products", e.id, "variants", t.id, "button_description", GPOParams.button_description || "");
    jQ("#quick-pre-order").length > 0 && jQ("#quick-pre-order").remove(),
    GPOParams.quickview_addtocart_selector.clone().insertAfter(GPOParams.quickview_addtocart_selector).removeAttr("name").attr("id", "quick-pre-order").removeClass("sca-qv-cartbtn"),
    jQ("#quick-pre-order").is("input") ? jQ("#quick-pre-order").val(n) : jQ("#quick-pre-order").text(n),
    jQ("#quick-pre-order").first().removeClass("gpo-hidden").prop("type", "submit").prop("disabled", !1).removeClass("disabled"),
    jQ("#quick-pre-order").off("click").unbind("click").click(function() {
        var t = jQ(this).closest("form[action*='cart'], form[action*='checkout']")
          , n = t.serializeArray()
          , i = 1
          , r = 0;
        return jQ(n).each(function(t, e) {
            "quantity" == e.name && (i = e.value),
            "id" == e.name && (r = e.value)
        }),
        GPOApp.addProductToCart(t, e, r, i, function() {
            "undefined" != typeof GPOAddToCartCallback ? GPOAddToCartCallback() : window.location.href = "/cart"
        }),
        !1
    }),
    i.length > 0 && jQ("#quick-pre-order").mouseenter(function() {
        var t = jQ("#quick-pre-order").offset().top
          , e = jQ("#quick-pre-order").outerWidth()
          , n = jQ("#quick-pre-order").offset().left
          , r = (jQ("#quick-pre-order").outerHeight(),
        parseInt(jQ("html").css("padding-top")));
        jQ('<div class="GPO_tooltip ' + "tooltip_top" + '" ' + ('style="left:' + (n + e / 2) + "px; top:" + (t - r) + 'px"') + ">" + i + "</div>").appendTo("body").fadeIn()
    }).mouseleave(function() {
        jQ(".GPO_tooltip").fadeOut(300, function() {
            jQ(".GPO_tooltip").remove()
        })
    }),
    gpoProduct.showQuickViewCountdown(t, e)
}
,
gpoProduct.showQuickViewCountdown = function(t, e) {
    var n = {
        weekday: "long",
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    };
    if (GPOApp.getVariantOrProductOrDefault(GPOParams, "products", e.id, "variants", t.id, "show_timer", !1)) {
        GPOParams.quickview_addtocart_selector.addClass("gpo-hidden"),
        jQ("#gpo-quick-na-message").addClass("gpo-hidden");
        var i = new Date
          , r = GPOApp.getVariantOrProductOrDefault(GPOParams, "products", e.id, "variants", t.id, "finished_at", !1) - i.getTime();
        if (r > 0) {
            console.log("showQuickViewCountdown"),
            jQ("#GPO-quick-countdown").length || jQ('<div id="GPO-quick-countdown"></div>').insertAfter(jQ(GPOParams.quickview_selector).find("form[action*='cart']").first());
            var o = GPOApp.getVariantOrProductOrDefault(GPOParams, "products", e.id, "variants", t.id, "available_auto", !1)
              , a = GPOApp.getVariantOrProductOrDefault(GPOParams, "products", e.id, "variants", t.id, "available_at", !1);
            if (o && a && GPOParams.preorder_avaiable_message.length) {
                var s = new Date(a);
                jQ("#GPO-quick-available-text").length ? jQ("#GPO-quick-available-text").text(GPOParams.preorder_avaiable_message + " " + s.toLocaleString("en-us", n)).removeClass("gpo-hidden").show() : jQ('<p id="GPO-quick-available-text">' + GPOParams.preorder_avaiable_message + " " + s.toLocaleString("en-us", n) + "</p>").insertAfter("#GPO-quick-countdown")
            }
            jQ("#GPO-quick-countdown").FlipClock(r / 1e3, {
                clockFace: "DailyCounter",
                countdown: !0,
                callbacks: {
                    stop: function() {
                        location.reload()
                    }
                }
            }),
            jQ("#GPO-quick-countdown").removeClass("gpo-hidden")
        }
    }
}
;
try {
    GPOApp.init()
} catch (t) {
    console.log("Pre-Order Pro by Globo exception: " + t)
}
